import {
  deleteRequest,
  getRequest,
  postRequest,
} from '../../../helpers/request.js';
import {
  hideLoader,
  showLoader,
  // toShowComponents,
} from '../../../helpers/utils';

import $ from 'jquery';
import { API_HOST, DOMAIN } from '../../../configs/api';
import bootstrap from './bootstrap/index';
import { createComponentManager } from '../../../helpers/componentManager.js';
import { createDocManager } from '../../../helpers/docManager.js';
import { createEditorModal } from '../../../helpers/monacoEditor';
import { createUploadFontModal } from '../../../helpers/customFont';
import { createVideoManager } from '../../../helpers/videoManager.js';
import download from 'downloadjs';
import { dragModePopup } from '../../../helpers/dragModePopup.js';
import { fnMapToLink } from './add_link/draw_link.js';
import { nthChildPopup } from '../../../helpers/nthChildManager.js';
import table from './table/index';
import { openCustomAttributePopup } from '../../../helpers/addCustomAttributes.helper.js';

import veevaLogo from "../../../images/veeva-logo.jpeg";
import vaeLogo from "../../../images/vae-logo.jpeg";
import { validateImageName } from '../../../helpers/validation.js';

// import { modal } from "./modal";

// * ::-webkit-scrollbar-track { background: rgba(0, 0, 0, 0.1) }
// * ::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.2) }
// * ::-webkit-scrollbar { width: 10px }

export const renderThumbImage = (src) => `<img alt="Thumbnail" draggable="false" class="block-media-img" src="${src}" />`;

export const gjsCanvassDefaultStyles = `
body { background-color: #fff; overflow-y: auto; }
::-webkit-scrollbar, .gjs-frame::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #000;
}
::-webkit-scrollbar-thumb:hover {
  background: #034ea2;
}`;

export const bootstrapDefaultStyles = `
${gjsCanvassDefaultStyles}
.gjs-dashed .container, .gjs-dashed .container-fluid,
.gjs-dashed .row,
.gjs-dashed .col, .gjs-dashed [class^="col-"] {
  min-height: 1.5rem !important;
}
.gjs-dashed .w-100 {
  min-height: .25rem !important;
  background-color: rgba(0,0,0,0.1);
}
.gjs-dashed img {
  min-width: 25px;
  min-height: 25px;
  background-color: rgba(0,0,0,0.5);
}
.gjs-dashed .btn-group,
.gjs-dashed .btn-toolbar {
  padding-right: 1.5rem !important;
  min-height: 1.5rem !important;
}
.gjs-dashed .card,
.gjs-dashed .card-group, .gjs-dashed .card-deck, .gjs-dashed .card-columns {
  min-height: 1.5rem !important;
}
.gjs-dashed .collapse {
  display: block !important;
  min-height: 1.5rem !important;
}
.gjs-dashed .dropdown {
  display: block !important;
  min-height: 1.5rem !important;
}
.gjs-dashed .dropdown-menu {
  min-height: 1.5rem !important;
  display: block !important;
}
`;

const listTypeOptions = [
  { value: 'none', name: 'none' },
  { value: 'disc', name: 'default' },
  { value: 'armenian', name: 'armenian' },
  { value: 'circle', name: 'circle' },
  { value: 'cjk-ideographic', name: 'cjk-ideographic' },
  { value: 'decimal', name: 'decimal' },
  { value: 'decimal-leading-zero', name: 'decimal-leading-zero' },
  { value: 'georgian', name: 'georgian' },
  { value: 'hebrew', name: 'hebrew' },
  { value: 'hiragana', name: 'hiragana' },
  { value: 'hiragana-iroha', name: 'hiragana-iroha' },
  { value: 'katakana', name: 'katakana' },
  { value: 'katakana-iroha', name: 'katakana-iroha' },
  { value: 'lower-alpha', name: 'lower-alpha' },
  { value: 'lower-alpha', name: 'lower-alpha' },
  { value: 'lower-latin', name: 'lower-latin' },
  { value: 'lower-roman', name: 'lower-roman' },
  { value: 'square', name: 'square' },
  { value: 'upper-alpha', name: 'upper-alpha' },
  { value: 'upper-greek', name: 'upper-greek' },
  { value: 'upper-latin', name: 'upper-latin' },
  { value: 'upper-roman', name: 'upper-roman' },
  { value: 'initial', name: 'initial' },
  { value: 'inherit', name: 'inherit' },
];

export const styleManager = (pathName) => {
  const fontFamilyProperty =
    pathName && pathName.includes('imports')
      ? {
        full: true,
        type: 'datalist',
        label: 'Font',
        property: 'font-family',
        default: 'Arial',
        options: [
          { value: 'Arial', name: 'Arial' },
          { value: 'Arial Black', name: 'Arial Black' },
          { value: 'Brush Script MT', name: 'Brush Script MT' },
          { value: 'Comic Sans MS', name: 'Comic Sans MS' },
          { value: 'Courier New', name: 'Courier New' },
          { value: 'Georgia', name: 'Georgia' },
          { value: 'Helvetica', name: 'Helvetica' },
          { value: 'Impact', name: 'Impact' },
          { value: 'Lucida Sans Unicode', name: 'Lucida Sans Unicode' },
          { value: 'Tahoma', name: 'Tahoma' },
          { value: 'Times New Roman', name: 'Times New Roman' },
          { value: 'Trebuchet MS', name: 'Trebuchet MS' },
          { value: 'Verdana', name: 'Verdana' },
        ],
      }
      : { name: 'Font', property: 'font-family', full: true };

  return {
    hideNotStylable: false,
    appendTo: '#styles-container',
    sectors: [
      {
        name: 'General',
        buildProps: [
          'float',
          'display',
          'position',
          'top',
          'right',
          'left',
          'bottom',
          'overflow-x',
          'overflow-y',
          'z-index',
          'visibility',
        ],
        properties: [
          {
            name: 'Alignment [Float]',
            property: 'float',
            type: 'radio',
            defaults: 'none',
            list: [
              { value: 'none', className: 'fa fa-times' },
              { value: 'left', className: 'fa fa-align-left' },
              { value: 'right', className: 'fa fa-align-right' },
            ],
          },
          { property: 'position', type: 'select' },
          {
            type: 'number',
            // type: "slider",
            property: 'z-index',
            // defaults: 1,
            step: 1,
            // max: 100,
            // min: -100,
          },
          {
            type: 'select',
            label: 'Overflow-X',
            property: 'overflow-x',
            default: 'auto',
            options: [
              { id: 'auto', label: 'Auto' },
              { id: 'scroll', label: 'Scroll' },
              { id: 'visible', label: 'Visible' },
              { id: 'hidden', label: 'Hidden' },
            ],
          },
          {
            type: 'select',
            label: 'Overflow-Y',
            property: 'overflow-y',
            default: 'auto',
            options: [
              { id: 'auto', label: 'Auto' },
              { id: 'scroll', label: 'Scroll' },
              { id: 'visible', label: 'Visible' },
              { id: 'hidden', label: 'Hidden' },
            ],
          },
          {
            type: 'select',
            label: 'Visibility',
            property: 'visibility',
            default: 'visible',
            options: [
              { id: 'visible', label: 'Visible' },
              { id: 'hidden', label: 'Hidden' },
              { id: 'collapse', label: 'Collapse' },
              { id: 'initial', label: 'Initial' },
              { id: 'inherit', label: 'Inherit' },
            ],
          },
          {
            id: 'cursor',
            type: 'select',
            property: 'cursor',
            label: 'Cursor',
            default: 'auto',
            options: [
              { id: 'auto', label: 'auto' },
              { id: 'none', label: 'none' },
              { id: 'alias', label: 'alias' },
              { id: 'all-scroll', label: 'all-scroll' },
              { id: 'cell', label: 'cell' },
              { id: 'col-resize', label: 'col-resize' },
              { id: 'context-menu', label: 'context-menu' },
              { id: 'copy', label: 'copy' },
              { id: 'crosshair', label: 'crosshair' },
              { id: 'e-resize', label: 'e-resize' },
              { id: 'ew-resize', label: 'ew-resize' },
              { id: 'grab', label: 'grab' },
              { id: 'grabbing', label: 'grabbing' },
              { id: 'help', label: 'help' },
              { id: 'move', label: 'move' },
              { id: 'n-resize', label: 'n-resize' },
              { id: 'ne-resize', label: 'ne-resize' },
              { id: 'nesw-resize', label: 'nesw-resize' },
              { id: 'ns-resize', label: 'ns-resize' },
              { id: 'nw-resize', label: 'nw-resize' },
              { id: 'nwse-resize', label: 'nwse-resize' },
              { id: 'no-drop', label: 'no-drop' },
              { id: 'not-allowed', label: 'not-allowed' },
              { id: 'pointer', label: 'pointer' },
              { id: 'progress', label: 'progress' },
              { id: 'row-resize', label: 'row-resize' },
              { id: 's-resize', label: 's-resize' },
              { id: 'se-resize', label: 'se-resize' },
              { id: 'sw-resize', label: 'sw-resize' },
              { id: 'text', label: 'text' },
              { id: 'vertical-text', label: 'vertical-text' },
              { id: 'w-resize', label: 'w-resize' },
              { id: 'wait', label: 'wait' },
              { id: 'zoom-in', label: 'zoom-in' },
              { id: 'zoom-out', label: 'zoom-out' },
            ],
          },
        ],
      },
      {
        name: 'Dimension',
        open: false,
        buildProps: [
          'width',
          'max-width',
          'min-width',
          'height',
          'max-height',
          'min-height',
          'margin',
          'padding',
        ],
        properties: [
          {
            property: 'width',
            type: 'number',
            default: 'auto',
            units: ['px', '%', 'em', 'rem', 'vh', 'vw'],
            fixedValues: [
              'initial',
              'inherit',
              'auto',
              'max-content',
              'min-content',
              'fit-content',
              'stretch',
            ],
            min: 0,
          },
          {
            property: 'height',
            type: 'number',
            default: 'auto',
            units: ['px', '%', 'em', 'rem', 'vh', 'vw'],
            fixedValues: [
              'initial',
              'inherit',
              'auto',
              'max-content',
              'min-content',
              'fit-content',
              'stretch',
            ],
            min: 0,
          },
          {
            id: 'flex-width',
            type: 'integer',
            name: 'Width',
            units: ['px', '%'],
            property: 'flex-basis',
            toRequire: 1,
          },
          {
            property: 'margin',
            properties: [
              { name: 'Top', property: 'margin-top' },
              { name: 'Right', property: 'margin-right' },
              { name: 'Bottom', property: 'margin-bottom' },
              { name: 'Left', property: 'margin-left' },
            ],
          },
          {
            property: 'padding',
            properties: [
              { name: 'Top', property: 'padding-top' },
              { name: 'Right', property: 'padding-right' },
              { name: 'Bottom', property: 'padding-bottom' },
              { name: 'Left', property: 'padding-left' },
            ],
          },
        ],
      },
      {
        name: 'Typography',
        open: false,
        buildProps: [
          'font-family',
          'font-size',
          'font-weight',
          'text-transform',
          'line-height',
          'letter-spacing',
          'word-spacing',
          'color',
          'text-align',
          'text-decoration',
          'text-shadow',
          'text-indent',
          'text-rendering',
          'list-style-type',
          '-webkit-text-stroke-width',
          '-webkit-text-stroke-color',
          '-webkit-text-fill-color',
          '-webkit-background-clip',
          'vertical-align',
        ],
        properties: [
          {
            name: 'Font size',
            property: 'font-size',
            full: true
          },
          {
            name: 'Line Height',
            property: 'line-height',
            full: true
          },
          {
            name: 'Letter spacing',
            property: 'letter-spacing',
            full: true
          },
          {
            name: 'Word spacing',
            property: 'word-spacing',
            full: true
          },
          {
            property: 'word-spacing',
            name: 'Word Spacing',
            type: 'number',
            units: [
              'px',
              '%',
              'pt',
              'pc',
              'in',
              'cm',
              'mm',
              'em',
              'ex',
              'rem',
              'vh',
              'vw',
            ],
            fixedValues: ['initial', 'inherit', 'normal'],
            default: 'normal',
          },
          {
            property: 'vertical-align',
            name: 'Vertical Align',
            type: 'select',
            default: 'baseline',
            options: [
              { value: 'baseline', name: 'baseline' },
              { value: 'sub', name: 'sub' },
              { value: 'super', name: 'super' },
              { value: 'text-top', name: 'text-top' },
              { value: 'text-bottom', name: 'text-bottom' },
              { value: 'top', name: 'top' },
              { value: 'bottom', name: 'bottom' },
              { value: 'initial', name: 'initial' },
              { value: 'inherit', name: 'inherit' },
            ],
          },
          {
            property: 'text-transform',
            name: 'Text Transform',
            type: 'select',
            default: 'none',
            options: [
              { value: 'none', name: 'none' },
              { value: 'capitalize', name: 'capitalize' },
              { value: 'uppercase', name: 'uppercase' },
              { value: 'lowercase', name: 'lowercase' },
            ],
          },
          { ...fontFamilyProperty },
          { name: 'Weight', property: 'font-weight' },
          { name: 'Font color', property: 'color' },
          {
            property: 'text-align',
            type: 'radio',
            defaults: 'left',
            list: [
              { value: 'left', name: 'Left', className: 'fa fa-align-left' },
              {
                value: 'center',
                name: 'Center',
                className: 'fa fa-align-center',
              },
              { value: 'right', name: 'Right', className: 'fa fa-align-right' },
              {
                value: 'justify',
                name: 'Justify',
                className: 'fa fa-align-justify',
              },
            ],
          },
          {
            property: 'text-decoration',
            type: 'radio',
            defaults: 'none',
            list: [
              { value: 'none', name: 'None', className: 'fa fa-times' },
              {
                value: 'underline',
                name: 'underline',
                className: 'fa fa-underline',
              },
              {
                value: 'line-through',
                name: 'Line-through',
                className: 'fa fa-strikethrough',
              },
            ],
          },
          {
            property: 'text-shadow',
            properties: [
              { name: 'X position', property: 'text-shadow-h' },
              { name: 'Y position', property: 'text-shadow-v' },
              { name: 'Blur', property: 'text-shadow-blur' },
              { name: 'Color', property: 'text-shadow-color' },
            ],
          },
          {
            name: 'List type',
            type: 'select',
            property: 'list-style-type',
            default: 'disc',
            options: listTypeOptions,
            full: true,
          },
          {
            name: 'Text Indent',
            type: 'integer',
            units: ['px'],
            default: '0',
            property: 'text-indent',
          },
          {
            name: 'Text Stroke Width',
            type: 'integer',
            units: ['px'],
            default: '0',
            property: '-webkit-text-stroke-width',
            full: true,
          },
          {
            name: 'Text Stroke Color',
            type: 'color',
            property: '-webkit-text-stroke-color',
          },
          {
            name: 'Text Fill Color',
            type: 'color',
            property: '-webkit-text-fill-color',
          },
          {
            name: 'Background Clip',
            type: 'text',
            property: '-webkit-background-clip',
          },
          {
            property: 'text-rendering',
            name: 'Text Rendering',
            type: 'select',
            default: 'auto',
            options: [
              { value: 'auto', name: 'auto' },
              { value: 'optimizeSpeed', name: 'optimizeSpeed' },
              { value: 'optimizeLegibility', name: 'optimizeLegibility' },
              { value: 'geometricPrecision', name: 'geometricPrecision' },
              { value: 'initial', name: 'Initial' },
              { value: 'inherit', name: 'Inherit' },
            ],
          },
          {
            name: 'Line Height',
            type: 'integer',
            units: [[], 'px', '%', 'em', 'rem', 'vh', 'vw'],
            // default: "0",
            property: 'line-height',
          },
        ],
      },
      {
        name: 'Decorations',
        open: false,
        buildProps: [
          "background-color",
          'background',
          'opacity',
          'border-radius',
          'border-color',
          'border-style',
          'border-width',
          'border-image',
          'border-image-slice',
          'box-shadow',
          'box-sizing',
          'outline-style',
        ],
        properties: [
          {
            type: 'slider',
            property: 'opacity',
            defaults: 1,
            step: 0.01,
            max: 1,
            min: 0,
          },
          {
            type: 'composite',
            property: 'border-width',
            label: 'Border Width',
            // Additional props
            properties: [
              {
                type: 'integer',
                units: ['px'],
                default: '0',
                property: 'border-top-width',
                full: true,
              },
              {
                type: 'integer',
                units: ['px'],
                default: '0',
                property: 'border-right-width',
                full: true,
              },
              {
                type: 'integer',
                units: ['px'],
                default: '0',
                property: 'border-bottom-width',
                full: true,
              },
              {
                type: 'integer',
                units: ['px'],
                default: '0',
                property: 'border-left-width',
                full: true,
              },
            ],
          },
          { name: 'Border color', property: 'border-color', type: 'color' },
          {
            name: 'Border style',
            property: 'border-style',
            default: 'none',
            list: [
              { value: 'none', name: 'None' },
              { value: 'dotted', name: 'Dotted' },
              { value: 'dashed', name: 'Dashed' },
              { value: 'solid', name: 'Solid' },
              { value: 'double', name: 'Double' },
              { value: 'groove', name: 'Groove' },
              { value: 'ridge', name: 'Ridge' },
              { value: 'inset', name: 'Inset' },
              { value: 'outset', name: 'Outset' },
            ],
          },
          {
            property: 'border-radius',
            properties: [
              { name: 'Top', property: 'border-top-left-radius' },
              { name: 'Right', property: 'border-top-right-radius' },
              { name: 'Bottom', property: 'border-bottom-left-radius' },
              { name: 'Left', property: 'border-bottom-right-radius' },
            ],
          },
          {
            property: 'border-image',
            type: 'composite',
            default: 'linear-gradient(to right, black 0%, white 100%)',
            properties: [
              {
                name: 'Gradient',
                type: 'gradient',
                property: 'border-image-gradient',
                default: 'linear-gradient(to right, black 0%, white 100%)',
                full: true,
              },
              {
                name: 'Direction',
                type: 'datalist',
                default: 'to right',
                property: 'border-image-direction',
                options: [
                  { value: 'to right', name: 'to right' },
                  { value: 'to bottom', name: 'to bottom' },
                  { value: 'to left', name: 'to left' },
                  { value: 'to top', name: 'to top' },
                ],
              },
              {
                name: 'Type',
                type: 'select',
                default: 'linear-gradient',
                property: 'border-image-type',
                list: [
                  { value: 'linear-gradient', name: 'linear' },
                  { value: 'radial-gradient', name: 'radial' },
                  {
                    value: 'repeating-linear-gradient',
                    name: 'repeating-linear',
                  },
                  {
                    value: 'repeating-radial-gradient',
                    name: 'repeating-radial',
                  },
                ],
              },
            ],
            fromStyle: (style) => {
              const gradient = style['border-image'];
              var direction_value = gradient.split('(')[1].split(',')[0];
              var type_value = gradient.split('(')[0];
              return {
                'border-image-gradient': gradient,
                'border-image-direction': direction_value,
                'border-image-type': type_value,
              };
            },
            toStyle: (values) => {
              const gradient =
                values['border-image-gradient'] ||
                'linear-gradient(to right, black 0%, white 100%)';
              const direction = values['border-image-direction'] || 'to right';
              const type = values['border-image-type'] || 'linear-gradient';
              var direction_value = gradient.split('(')[1].split(',')[0];
              var type_value = gradient.split('(')[0];
              const gradient_updated = gradient
                .replace(type_value, type)
                .replace(direction_value, direction);
              return {
                'border-image': `${gradient_updated}`,
              };
            },
          },
          {
            property: 'border-image-slice',
            type: 'integer',
            units: [[], 'px', '%'],
          },
          {
            property: 'box-shadow',
            properties: [
              { name: 'X position', property: 'box-shadow-h' },
              { name: 'Y position', property: 'box-shadow-v' },
              { name: 'Blur', property: 'box-shadow-blur' },
              { name: 'Spread', property: 'box-shadow-spread' },
              { name: 'Color', property: 'box-shadow-color' },
              { name: 'Shadow type', property: 'box-shadow-type' },
            ],
          },
          {
            type: 'select',
            name: 'Box Sizing',
            property: 'box-sizing',
            default: 'content-box',
            list: [
              { value: 'content-box', name: 'Content Box' },
              { value: 'border-box', name: 'Border Box' },
              { value: 'initial', name: 'Initial' },
              { value: 'inherit', name: 'Inherit' },
            ],
          },
          {
            type: 'select',
            name: 'Outline style',
            property: 'outline-style',
            default: 'none',
            list: [
              { value: 'none', name: 'None' },
              { value: 'dotted', name: 'Dotted' },
              { value: 'dashed', name: 'Dashed' },
              { value: 'solid', name: 'Solid' },
              { value: 'double', name: 'Double' },
              { value: 'groove', name: 'Groove' },
              { value: 'ridge', name: 'Ridge' },
              { value: 'inset', name: 'Inset' },
              { value: 'outset', name: 'Outset' },
              { value: 'hidden', name: 'Hidden' },
            ],
          },
          {
            type: "color",
            name: "Background-Color",
            property: "background-color",
          },
          // {
          //   id: "background-bg",
          //   property: "background",
          //   type: "bg",
          // },
        ],
      },
      {
        name: 'Extra',
        open: false,
        buildProps: ['transition', 'transform', 'perspective', "pointer-events"],
        properties: [
          {
            property: 'transform',
            type: 'stack',
            layerSeparator: ' ',
            properties: [
              {
                property: 'transform-type',
                name: 'Type',
                type: 'select',
                default: 'rotateZ',
                full: true,
                options: [
                  {
                    id: 'scaleX',
                    propValue: {
                      units: [''],
                      step: 0.01,
                    },
                  },
                  {
                    id: 'scaleY',
                    propValue: {
                      units: [''],
                      step: 0.01,
                    },
                  },
                  {
                    id: 'scaleZ',
                    propValue: {
                      units: [''],
                      step: 0.01,
                    },
                  },
                  {
                    id: 'rotateX',
                    propValue: {
                      units: ['deg', 'rad', 'grad'],
                      step: 1,
                    },
                  },
                  {
                    id: 'rotateY',
                    propValue: {
                      units: ['deg', 'rad', 'grad'],
                      step: 1,
                    },
                  },
                  {
                    id: 'rotateZ',
                    propValue: {
                      units: ['deg', 'rad', 'grad'],
                      step: 1,
                    },
                  },
                  {
                    id: 'skewX',
                    propValue: {
                      units: ['deg', 'rad', 'grad'],
                      step: 1,
                    },
                  },
                  {
                    id: 'skewY',
                    propValue: {
                      units: ['deg', 'rad', 'grad'],
                      step: 1,
                    },
                  },
                  {
                    id: 'translateX',
                    propValue: {
                      units: ['px', '%', 'em', 'rem', 'vh', 'vw'],
                      step: 1,
                    },
                  },
                  {
                    id: 'translateY',
                    propValue: {
                      units: ['px', '%', 'em', 'rem', 'vh', 'vw'],
                      step: 1,
                    },
                  },
                ],
              },
              {
                property: 'transform-value',
                type: 'number',
                default: '0',
                full: true,
              },
            ],
          },
          {
            id: 'appearance',
            type: 'radio',
            property: 'appearance',
            label: 'Hide Arrow for Select tag',
            default: 'auto',
            options: [
              { id: 'auto', label: 'Show' },
              { id: 'none', label: 'Hide' },
            ],
            toRequire: 1,
          },
          {
            id: 'pointer-events',
            type: 'select',
            property: 'pointer-events',
            label: 'Pointer Events',
            default: 'auto',
            options: [
              { id: 'auto', label: 'auto' },
              { id: 'none', label: 'none' },
              { id: 'initial', label: 'initial' },
              { id: 'inherit', label: 'inherit' },
            ],
          },
        ],
      },
      // {
      //   name: "Extra",
      //   open: false,
      //   buildProps: ["transition", "perspective", "transform"],
      //   properties: [
      //     {
      //       property: "transition",
      //       properties: [
      //         { name: "Property", property: "transition-property" },
      //         { name: "Duration", property: "transition-duration" },
      //         { name: "Easing", property: "transition-timing-function" },
      //       ],
      //     },
      //     {
      //       property: "transform",
      //       properties: [
      //         {
      //             name: "Transform type",
      //             property: "transform",
      //             type: 'select',
      //             label: "Transform type",
      //             options: [
      //                 { value: 'rotateX', label: "rotateX" },
      //                 { value: 'rotateY', label: "rotateY" },
      //             ]
      //         },
      //         // {
      //         //     name: "Transform value",
      //         //     // property: "transform-rotate-x",
      //         //     type: 'number',
      //         //     label: "Transform value",
      //         //     units: ['deg', 'rad', 'turn'],

      //         // },

      //         // {
      //         //     name: "Rotate X",
      //         //     property: "transform-rotate-x",
      //         //     type: 'number',
      //         //     label: "Rotate X",
      //         //     functionName: "rotateX",
      //         //     units: ['deg', 'rad', 'turn'],

      //         // },

      //         // { name: "Rotate Y", property: "transform-rotate-y" },
      //         // { name: "Rotate Z", property: "transform-rotate-z" },
      //         // { name: "Scale X", property: "transform-scale-x" },
      //         // { name: "Scale Y", property: "transform-scale-y" },
      //         // { name: "Scale Z", property: "transform-scale-z" },
      //       ],
      //     },
      //   ],
      // },
      {
        name: 'Flex',
        open: false,
        properties: [
          {
            name: 'Flex Container',
            property: 'display',
            type: 'select',
            defaults: 'block',
            list: [
              { value: 'block', name: 'Disable' },
              { value: 'flex', name: 'Enable' },
            ],
          },
          {
            name: 'Flex Parent',
            property: 'label-parent-flex',
            type: 'integer',
          },
          {
            name: 'Direction',
            property: 'flex-direction',
            type: 'radio',
            list: [
              {
                value: 'row',
                // name: "Row",
                className: 'icons-flex icon-dir-row',
                title: 'Row',
              },
              {
                value: 'row-reverse',
                // name: "Row reverse",
                className: 'icons-flex icon-dir-row-rev',
                title: 'Row reverse',
              },
              {
                value: 'column',
                // name: "Column",
                title: 'Column',
                className: 'icons-flex icon-dir-col',
              },
              {
                value: 'column-reverse',
                // name: "Column reverse",
                title: 'Column reverse',
                className: 'icons-flex icon-dir-col-rev',
              },
            ],
          },
          {
            name: 'Justify',
            property: 'justify-content',
            type: 'radio',
            list: [
              {
                value: 'flex-start',
                // name: "Start",
                className: 'icons-flex icon-just-start',
                title: 'Start',
              },
              {
                value: 'flex-end',
                title: 'End',
                // name: "End",
                className: 'icons-flex icon-just-end',
              },
              {
                value: 'space-between',
                title: 'Space between',
                // name: "Space between",
                className: 'icons-flex icon-just-sp-bet',
              },
              {
                value: 'space-around',
                title: 'Space around',
                // name: "Space around",
                className: 'icons-flex icon-just-sp-ar',
              },
              {
                value: 'center',
                title: 'Center',
                // name: "Center",
                className: 'icons-flex icon-just-sp-cent',
              },
            ],
          },
          {
            name: 'Align-Items',
            property: 'align-items',
            type: 'radio',
            list: [
              {
                value: 'flex-start',
                title: 'Start',
                // name: "Start",
                className: 'icons-flex icon-al-start',
              },
              {
                value: 'flex-end',
                title: 'End',
                // name: "End",
                className: 'icons-flex icon-al-end',
              },
              {
                value: 'stretch',
                title: 'Stretch',
                // name: "Stretch",
                className: 'icons-flex icon-al-str',
              },
              {
                value: 'center',
                title: 'Center',
                // name: "Center"
                className: 'icons-flex icon-al-center',
              },
            ],
          },
          {
            name: 'Flex Children',
            property: 'label-parent-flex',
            type: 'integer',
          },
          {
            name: 'Order',
            property: 'order',
            type: 'integer',
            defaults: 0,
            min: 0,
          },
          {
            name: 'Flex',
            property: 'flex',
            type: 'composite',
            properties: [
              {
                name: 'Grow',
                property: 'flex-grow',
                type: 'integer',
                defaults: 0,
                min: 0,
              },
              {
                name: 'Shrink',
                property: 'flex-shrink',
                type: 'integer',
                defaults: 0,
                min: 0,
              },
              {
                name: 'Basis',
                property: 'flex-basis',
                type: 'integer',
                units: ['px', '%', ''],
                unit: '',
                defaults: 'auto',
                full: true,
              },
            ],
          },
          {
            name: 'Align-Self',
            property: 'align-self',
            type: 'radio',
            list: [
              {
                value: 'auto',
                name: 'Auto',
              },
              {
                value: 'flex-start',
                title: 'Start',
                // name: "Start",
                className: 'icons-flex icon-al-start',
              },
              {
                value: 'flex-end',
                title: 'End',
                // name: "End",
                className: 'icons-flex icon-al-end',
              },
              {
                value: 'stretch',
                title: 'Stretch',
                // name: "Stretch",
                className: 'icons-flex icon-al-str',
              },
              {
                value: 'center',
                title: 'Center',
                // name: "Center",
                className: 'icons-flex icon-al-center',
              },
            ],
          },
          {
            name: 'Flex-Wrap',
            property: 'flex-wrap',
            type: 'select',
            default: 'nowrap',
            full: true,
            options: [
              { id: 'nowrap', label: 'No Wrap' },
              { id: 'wrap', label: 'Wrap' },
              { id: 'wrap-reverse', label: 'Wrap Reverse' },
            ],
          },
        ],
      },
    ],
  };
};

export const layerManager = {
  appendTo: '#layers-container',
};

export const traitManager = {
  appendTo: '#trait-container',
};

export const selectorManager = {
  appendTo: '#selector-container',
  // componentFirst: true,
};

export const panels = (pathName) => ({
  defaults: [
    {
      id: 'basic-actions',
      el: '.panel__basic-actions',
      buttons: [
        {
          id: 'draw-box',
          className: 'fa fa-link btn-save',
          command: 'draw-box',
          context: 'draw-link',
          attributes: {
            title: 'Draw Link',
          },
        },
        {
          id: 'visibility',
          context: 'visibility',
          active: true, // active by default
          className: 'btn-toggle-borders',
          label: '<i class="fa fa-clone"></i>',
          command: 'sw-visibility', // Built-in command
          attributes: {
            title: 'Components View',
          },
        },
        {
          id: 'ruler-visibility',
          label: `<svg xmlns="http://www.w3.org/2000/svg" width="16" viewBox="0 0 16 16"><path d="M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5v-1H2v-1h4v-1H4v-1h2v-1H2v-1h4V9H4V8h2V7H2V6h4V2h1v4h1V4h1v2h1V2h1v4h1V4h1v2h1V2h1v4h1V1a1 1 0 0 0-1-1H1z"/></svg>`,
          context: 'toggle-rulers',
          command: {
            run(editor) {
              console.log("run ruler");
              editor.runCommand('ruler-visibility');
              editor.runCommand('guides-visibility');
            },
            stop(editor) {
              console.log("stop ruler");
              editor.stopCommand('ruler-visibility');
              editor.stopCommand('guides-visibility');
            },
          },
          attributes: {
            title: 'Toggle Rulers',
          },
        },
        {
          id: 'help',
          className: 'btn-toggle-borders float-right',
          label: '<i class="fa fa-question"></i>',
          command: 'help',
          attributes: {
            title: 'Help',
          },
        },
      ],
    },
    {
      id: 'editor-actions',
      el: '.panel__editor',
      buttons: [
        {
          id: 'saveDb',
          className: 'fa-regular fa-floppy-disk btn-save text-success',
          command: 'saveDb',
          attributes: {
            title: 'Save Design',
          },
        },
        //Added for replacing Thumb Image
        {
          id: 'saveThumbImage',
          className: 'fa fa-image btn-save',
          command: 'saveThumbImage',
          attributes: {
            title: 'Save Thumb Image',
          },
        },
        {
          id: 'cmd-clear',
          className: 'fa-regular fa-trash-can text-danger',
          command: 'cmd-clear',
          attributes: {
            title: 'Clear Canvas',
          },
        },
        {
          id: 'undo',
          className: 'fa fa-rotate-left',
          command: 'undo',
          attributes: {
            title: 'Undo',
          },
        },
        {
          id: 'redo',
          className: 'fa fa-rotate-right',
          command: 'redo',
          attributes: {
            title: 'Redo',
          },
        },
        {
          id: "view-in-new-tab",
          className: "fa-solid fa-arrow-up-right-from-square",
          command: {
            run: () => {
              // `${DOMAIN}/views/webapp/${currentWebAppId}/pages/${page._id}/view`
              // const url = `${DOMAIN}/views/${pathName}/view`;
              const url = `${DOMAIN}/view/${pathName}/dsp`;
              window.open(url, "_blank");
            },
          },
          attributes: {
            title: "View in New Tab",
          },
        },
        // {
        //   id: 'draw-box',
        //   className: 'fa fa-link btn-save',
        //   command: 'draw-box',
        //   attributes: {
        //     title: 'Draw Link',
        //   },
        // },
        // {
        //   id: "select-nth-child",
        //   label: '<small style="font-size: 0.8rem;">:nth-ch</small>',
        //   command: nthChildPopup,
        //   attributes: {
        //     title: "Select :nth-child()"
        //   },
        // },
        {
          id: 'dragModePopup',
          className: 'drag-mode-btn',
          label: 'DM: T',
          command: dragModePopup,
          attributes: {
            title: 'Current Drag Mode: Transform',
          },
        },
        // {
        //   id: "rotate",
        //   className: "fa fa-hourglass-end btn-save",
        //   command: "rotate",
        //   attributes: {
        //     title: "Rotate",
        //   },
        // },
        {
          id: 'zoomout',
          className: 'fa fa-minus-circle btn-save',
          command: 'zoomout',
          attributes: {
            title: 'Zoom out',
          },
        },
        {
          id: 'zoomin',
          className: 'fa fa-plus-circle btn-save',
          command: 'zoomin',
          attributes: {
            title: 'Zoom in',
          },
        },
        {
          id: 'reset-zoom',
          className: 'fa fa-refresh btn-save',
          command: 'reset-zoom',
          attributes: {
            title: 'Reset Zoom',
          },
        },
        //Added for opening Template html in another tab starts
        // {
        //   id: 'viewTemplate',
        //   className: 'fa fa-arrow-up',
        //   command: 'viewTemplate',
        //   attributes: {
        //     title: 'View Template',
        //   },
        // },
        //Added for opening Template html in another tab ends
      ],
    },
    {
      id: 'util-actions',
      el: '#panel-util-actions',
      buttons: [
        {
          id: 'edit',
          className: 'fa fa-edit',
          command: 'edit',
          attributes: {
            title: 'Edit',
          },
        },
        {
          id: 'fonts',
          className: 'fa fa-font',
          command: 'fonts',
          attributes: {
            title: 'Upload Fonts',
          },
        },
        {
          id: 'export',
          className: 'fa fa-download',
          command: 'export',
          attributes: {
            title: 'Export package',
          },
        },
      ],
    },
  ],
});

export const scripts = [
  'https://code.jquery.com/jquery-3.5.1.slim.min.js',
  'https://unpkg.com/swiper@7/swiper-bundle.min.js',
  'https://cdn.jsdelivr.net/npm/popper.js@1.16.1/dist/umd/popper.min.js',
  'https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/js/bootstrap.min.js',
  // "https://cdn.jsdelivr.net/npm/chart.js",
];

export const styles = [
  // "https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css",
  'https://unpkg.com/swiper@7/swiper-bundle.min.css',
  'https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css',
];

export const setZoom = (editor, value = 85) => {
  if (!editor) return;
  const min = 40;
  const max = 150;

  if (value < min) value = min;
  if (value > max) value = max;

  editor.Canvas.setZoom(value);

  const canvasEl = editor.Canvas.getElement();
  const framesWrapperEl = canvasEl.querySelector('.gjs-cv-canvas__frames');
  const percent = value / 100;

  document.querySelector('.zoom').innerHTML = parseInt(percent * 100) + '%';

  framesWrapperEl.style.width = `calc(100% / ${percent})`;
  framesWrapperEl.style.height = `calc(100% / ${percent})`;

  const xCoord = (canvasEl.offsetWidth - framesWrapperEl.offsetWidth) / 2;
  const yCoord = (canvasEl.offsetHeight - framesWrapperEl.offsetHeight) / 2;

  editor.Canvas.setCoords(xCoord, yCoord);

  // store zoom in localstorage
  localStorage.setItem('saved-zoom', value);
  return value;
};

export const addEditorCommand = (
  editor,
  pathName,
  setMsg,
  setError,
  presentation = null,
  keyMessage = null,
  config = null
) => {
  // rotate
  // editor.Commands.add("rotate", {
  //   run: (ed) => {
  //     const currentDevice = editor.DeviceManager.getSelected().id;
  //     const device = editor.DeviceManager.get(currentDevice).attributes;
  //   },
  // });

  //get zoom from localstorage
  const savedZoom = localStorage.getItem('saved-zoom');
  if (savedZoom) {
    setZoom(editor, savedZoom);
  } else setZoom(editor);

  // zoom in
  editor.Commands.add('zoomin', {
    run: (editor) => {
      const currentZoom = editor.Canvas.getZoom();
      return setZoom(editor, currentZoom + 5);
    },
  });

  // zoom out
  editor.Commands.add('zoomout', {
    run: (ed) => {
      const currentZoom = ed.Canvas.getZoom();
      return setZoom(ed, currentZoom - 5);
    },
  });

  editor.Commands.add('reset-zoom', {
    run: (editor) => {
      return setZoom(editor, 85);
    },
  });

  // Save Button
  editor.Commands.add('saveDb', {
    run: (editor, sender) => {
      showLoader();
      sender && sender.set('active');
      editor.store();
      let error;
      editor.once('storage:error:store', () => {
        error = true;
      });
      editor.once('storage:end:store', () => {
        if (!error) {
          hideLoader();
          setError(false);
          setMsg('Saved your changes successfully!!');
        } else {
          setError(true);
          hideLoader();
        }
        error = false;
      });
    },
  });

  //Added for replacing Thumb Image
  //Add pathname includes presenation condition
  editor.Commands.add('saveThumbImage', {
    run: async (editor, sender) => {
      try {
        showLoader();
        await postRequest(`${pathName}/generate-thumb`, {});
      } catch (error) {
        console.log(error);
      } finally {
        hideLoader();
      }
      // (async () => {
      //   // Create a browser instance
      //   const browser = await puppeteer.launch();

      //   // Create a new page
      //   const page = await browser.newPage();

      //   // Set viewport width and height
      //   await page.setViewport({ width: 1280, height: 720 });

      //   const website_url = 'https://www.bannerbear.com/blog/how-to-convert-html-into-pdf-with-node-js-and-puppeteer/';

      //   // Open URL in current page
      //   await page.goto(website_url, { waitUntil: 'networkidle0' });

      //   // Capture screenshot
      //   await page.screenshot({
      //     path: 'screenshot.jpg'
      //   });

      //   // Close the browser instance
      //   await browser.close();
      setMsg('Changed Thumb Image successfully!!');
      // })();
    },
  });

  //Added for opening Template html in another tab starts
  // editor.Commands.add('viewTemplate', {
  //   run: async (editor, sender) => {
  //     try {
  //       showLoader();
  //       await postRequest(`${pathName}/content`, {});
  //       const url = `${DOMAIN}/view/${pathName}/dsp`;
  //       window.open(url, '_blank');
  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       hideLoader();
  //     }
  //     setMsg('Opened Template in new tab successfully!!');
  //   },
  // });
  //Added for opening Template html in another tab ends
  //Clear Button
  editor.Commands.add('cmd-clear', {
    run: async (editor) => {
      if (!window.confirm('Are you sure??')) return;
      showLoader();
      try {
        const response = await getRequest(`assets/${pathName}/fonts`);
        if (response.data.isSuccess) {
          editor.DomComponents.clear();
          editor.CssComposer.clear();
          response.data.fonts.forEach((fontObj) => {
            const [fileName, fileExtension] = fontObj.fontName.split('.');
            if (fontObj.isShared === false) {
              let type = fileExtension === 'ttf' ? 'truetype' : 'opentype';
              let fontCss = `@font-face{font-family:${fileName};src:${fontObj.srcUrl} format(${type});font-weight:normal;font-style:normal;font-display:fallback;}`;
              if (editor.getCss().indexOf(fontCss) === -1) {
                editor.Css.addRules(fontCss);
              }
            }
          });
          await editor.store();
        }
      } catch (error) {
        if (error) {
          setError(true);
          setMsg(error);
        }
      }
      hideLoader();
    },
  });

  // Undo
  editor.Commands.add('undo', {
    run: (editor) => editor.UndoManager.undo(),
  });

  // Redo
  editor.Commands.add('redo', {
    run: (editor) => editor.UndoManager.redo(),
  });

  // Download
  editor.Commands.add('export', {
    run: async (editor) => {
      if (pathName.includes('templates')) {
        setError(true);
        setMsg('Templates cannot be exported.');
      } else {
        showLoader();
        if (editor.getDirtyCount() > 0) await editor.store();
        const response = await fetch(`${API_HOST}${pathName}/download`);
        if (!response.ok) {
          if (response.statusText) {
            setError(true);
            setMsg(response.statusText);
          }
        } else {
          const blob = await response.blob();
          const downloadKeyMessageName =
            keyMessage && presentation && config
              ? keyMessage.isShared && config.RENAME_SHARED_DOWNLOAD
                ? `${presentation.name}_${keyMessage.name}.zip`
                : `${keyMessage.name}.zip`
              : (localStorage.getItem('key-message-name') || 'package') +
              '.zip';
          download(blob, downloadKeyMessageName);
          setError(false);
          setMsg('Downloaded KeyMessage Successfully');
        }
        hideLoader();
      }
    },
  });

  // Edit
  editor.Commands.add('edit', {
    run: async (editor) => {
      showLoader();
      createEditorModal(editor, pathName, setMsg, setError);
    },
  });

  // Fonts
  editor.Commands.add('fonts', {
    run: async (editor) => {
      createUploadFontModal(editor, pathName, setMsg, setError);
    },
  });

  editor.Commands.add('videos', (editor, sender, component) => {
    createVideoManager(
      editor,
      pathName,
      component.videoComponent,
      setMsg,
      setError,
      presentation
    );
  });

  editor.Commands.add('docs', (editor, sender, component) => {
    createDocManager(
      editor,
      pathName,
      component.docComponent,
      setMsg,
      setError,
      presentation
    );
  });

  editor.Commands.add('new-tool-cmd', {
    run: (editor) => console.log('Checking New Toolbar'),
  });

  editor.Commands.add('help', {
    run: () => {
      window.open(
        'https://indegene123.sharepoint.com/sites/WPS/SitePages/DSP-Editor.aspx?OR=Teams-HL&CT=1680672205605&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyOC8yMzAzMDUwMTExMCIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D',
        '_blank'
      );
    },
  });

  editor.Commands.add('draw-box', {
    run: (editor) => fnMapToLink(editor),
    stop: (editor) => {
      const editorIframeBody = editor.Canvas.getBody();
      if (editorIframeBody.getElementsByTagName('canvas').length > 0) {
        editorIframeBody.querySelector('canvas').style.display = 'none';
      }
    },
  });
};



export const openVideoManagerOnAddingVideo = (editor) => {
  const mutedTrait = {
    name: 'muted',
    label: 'Muted',
    type: 'checkbox',
  };

  // editor.on('block:drag:stop', (addedComponent, block) => {
  editor.on("canvas:drop", (dataTransfer, addedComponent) => {
    const block = window.currentDraggedBlock;
    addedComponent = Array.isArray(addedComponent) ? addedComponent[0] : addedComponent;
    if (
      addedComponent &&
      block.getId() === 'video' &&
      addedComponent.is('video')
    ) {
      editor.runCommand('videos', { videoComponent: addedComponent });

      addedComponent.view.$el.on('dblclick', (e) => {
        e.stopImmediatePropagation();
        editor.runCommand('videos', { videoComponent: addedComponent });
      });

      addedComponent.addTrait(mutedTrait);
    }
  });

  let videoComponents = editor.getWrapper().findType('video');
  for (let videoComponent of videoComponents) {
    videoComponent.view.$el.on('dblclick', (e) => {
      e.stopImmediatePropagation();
      editor.runCommand('videos', { videoComponent });
    });

    videoComponent.addTrait(mutedTrait);

    const mutedValue = videoComponent?.attributes?.attributes?.muted || false;
    const $video = videoComponent.view.$el.find('video');
    $video.prop('muted', mutedValue);
  }

  editor.on('component:update', (model) => {
    if (
      model.is('video') &&
      model?.changed?.attributes?.hasOwnProperty('muted')
    ) {
      const mutedValue = model?.changed?.attributes?.muted;
      const $video = model.view.$el.find('video');
      $video.prop('muted', mutedValue);
    }
  });
};

export const grapesJsStyleBGPluginOpts = (prop) => {
  const bgPositionId = 'background-position';
  const bgSizeId = 'background-size';

  const bgPositionAndSizeOpts = {
    [bgPositionId]: {
      type: 'datalist',
      label: 'Background-Position',
      property: bgPositionId,
      default: 'left top',
      options: [
        { value: 'left top', name: 'left top' },
        { value: 'left center', name: 'left center' },
        { value: 'left bottom', name: 'left bottom' },
        { value: 'right top', name: 'right top' },
        { value: 'right center', name: 'right center' },
        { value: 'right bottom', name: 'right bottom' },
        { value: 'center top', name: 'center top' },
        { value: 'center center', name: 'center center' },
        { value: 'center bottom', name: 'center bottom' },
      ],
    },
    [bgSizeId]: {
      type: 'datalist',
      label: 'Background-Size',
      property: bgSizeId,
      default: 'auto',
      options: [
        { value: 'auto', name: 'auto' },
        { value: 'cover', name: 'cover' },
        { value: 'contain', name: 'contain' },
      ],
    },
  };

  if (Object.keys(bgPositionAndSizeOpts).includes(prop.property)) {
    const returnProp = bgPositionAndSizeOpts[prop.property];
    return returnProp;
  } else return prop;
};

export const dataListTypePlugin = (editor) => {
  editor.StyleManager.addType('datalist', {
    // Create UI
    create({ props, change }) {
      const propId = props.id;
      const propOptions = props.options; // [{option: value}]

      const el = document.createElement('div');
      el.classList.add('gjs-field', 'gjs-input');

      const inputId = `${propId}-datalist-input`;
      const dataListId = `${propId}-datalist`;

      const optionString = propOptions
        .map(
          (option) =>
            `<option value="${option.value}" label="${option.name}"></option>`
        )
        .join('');

      el.innerHTML = `
                <input
                    id="${inputId}"
                    class="datalist-input"
                    name="${inputId}"
                    list="${dataListId}"
                />
                <datalist id="${dataListId}">
                    ${optionString}
                </datalist>
            `;

      const inputEl = el.querySelector(`#${inputId}`);
      inputEl.addEventListener('change', (event) => change({ event }));

      if (propId === 'font-family') {
        editor.on('style:property:update', (propertyOpts) => {
          const { property } = propertyOpts;
          if (
            property.attributes?.type === 'datalist' &&
            property.attributes?.id === propId
          ) {
            const updatedOptions = property.get('options');
            const updatedOptionString = updatedOptions
              .map(
                (option) =>
                  `<option value="${option.value}" label="${option.name}"></option>`
              )
              .join('');
            document.querySelector(`datalist#${dataListId}`).innerHTML =
              updatedOptionString;
          }
        });
      }

      return el;
    },

    // Propagate UI changes up to the targets
    emit({ props, updateStyle }, { event, partial }) {
      const initialValue = event.target.value;
      let finalValue = initialValue.toString().trim();
      if (finalValue === '') {
        event.target.value = props.default;
        updateStyle(props.default);
      } else updateStyle(finalValue);
    },

    // Update UI (eg. when the target is changed)
    update({ value, el }) {
      const finalValue = value.toString().trim();
      el.querySelector('input.datalist-input').value = finalValue;
    },

    // Clean the memory from side effects if necessary (eg. global event listeners, etc.)
    destroy(props) {
      // console.log("destroy", props);
    },
  });
};

export const addHeaders = (editor) => {
  const headings = [
    {
      tag: 'h1',
      slug: 'header_one',
      name: 'Header One',
      description: 'H1 Header',
      num: '1',
    },
    {
      tag: 'h2',
      slug: 'header_two',
      name: 'Header Two',
      description: 'H2 Header',
      num: '2',
    },
    {
      tag: 'h3',
      slug: 'header_three',
      name: 'Header three',
      description: 'H3 Header',
      num: '3',
    },
    {
      tag: 'h4',
      slug: 'header_four',
      name: 'Header four',
      description: 'H4 Header',
      num: '4',
    },
    {
      tag: 'h5',
      slug: 'header_five',
      name: 'Header five',
      description: 'H5 Header',
      num: '5',
    },
    {
      tag: 'h6',
      slug: 'header_six',
      name: 'Header six',
      description: 'H6 Header',
      num: '6',
    },
  ];

  headings.forEach((header) => {
    editor.BlockManager.add(header.slug, {
      category: 'Headings',
      media: `<span class="fa-solid fa-heading"></span><span class="fa-solid ms-1"> ${header.num}</span>`,
      label: `${header.name}`,
      content: `<${header.tag} data-gjs-type="text">${header.description}</${header.tag}>`,
    });
  });
};

export const addHR = (editor) => {
  editor.BlockManager.add('hr', {
    category: 'Typography',
    media: `<span class="fa-solid">HR</span>`,
    label: `Hr`,
    content: `<hr />`,
  });

  editor.BlockManager.add('para', {
    category: 'Typography',
    media: `
      <svg aria-hidden="true" width="24" height="50" focusable="false" data-prefix="fas" data-icon="paragraph" class="svg-inline--fa fa-paragraph fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"></path></svg>
    `,
    label: `Paragraph`,
    content: `<p>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus.</p>`,
  });
};

// make rows and cells resizable
const rowResizableOpts = {
  tl: 0,
  tc: 0,
  tr: 0,
  cl: 0,
  cr: 0,
  bl: 0,
  br: 0,
  minDim: 1,
};

const cellResizableOpts = {
  tl: 0,
  tc: 0,
  tr: 0,
  cl: 0,
  cr: 1,
  bl: 0,
  br: 0,
  minDim: 1,
  bc: 0,
  currentUnit: 1,
  step: 0.2,
  keyWidth: 'flex-basis',
};

export const makeRowsCellsResizable = (editor) => {
  let editorWrapper = editor.getWrapper();
  let editorRows = editorWrapper.find('.gjs-row');
  let editorCells = editorWrapper.find('.gjs-cell');

  editorRows.forEach((row) => {
    row.attributes.resizable = { ...rowResizableOpts };
  });

  editorCells.forEach((cell) => {
    cell.attributes.resizable = { ...cellResizableOpts };
  });
};

export const enableDraggingFormElements = (editor) => {
  const domc = editor.DomComponents;
  const inputBlocks = ['input', 'select', 'checkbox', 'radio'];
  inputBlocks.forEach((inputBlock) => {
    domc.addType(inputBlock, { model: { defaults: { draggable: true } } });
  });
};

export const closeAssetManagerOnAssetSelect = (
  editor,
  pathName,
  presentation
) => {
  // to render images every time asset manager is opened
  editor.on('asset:open', () => {
    renderAssetManager(editor, pathName, presentation);
  });

  const closeAssetManager = (e) => {
    e.stopImmediatePropagation();
    editor.AssetManager.close();
  };

  editor.on('asset:open', () => {
    $('body').on(
      'click',
      '.gjs-am-assets .gjs-am-asset, .gjs-am-assets .gjs-am-asset-image',
      closeAssetManager
    );
  });

  editor.on('asset:close', () => {
    $('body').off(
      'click',
      '.gjs-am-assets .gjs-am-asset, .gjs-am-assets .gjs-am-asset-image',
      closeAssetManager
    );
  });
};

export const richTextEditor = (editor) => {
  const rte = editor.RichTextEditor;

  rte.globalRte.__onPaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text').replaceAll("\n", "<br>");
    rte.globalRte.doc.execCommand('insertHTML', false, text);
  };

  const btnState = {
    ACTIVE: 1,
    INACTIVE: 0,
    DISABLED: -1,
  };

  const wrapSelectionWithDocLink = (child) => {
    return `<a data-role="Doc-Link">${child}</a>`;
  };

  const customElAttr = 'data-selectme';
  const isValidTag = (rte, tagName = 'A') => {
    const { anchorNode, focusNode } = rte.selection() || {};
    const parentAnchor = anchorNode?.parentNode;
    const parentFocus = focusNode?.parentNode;
    return (
      parentAnchor?.nodeName === tagName || parentFocus?.nodeName === tagName
    );
  };
  rte.remove('wrap');
  rte.add('wrap', {
    name: 'wrap',
    icon: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14A3,3 0 0,0 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21A4,4 0 0,0 10,17A3,3 0 0,0 7,14Z" />
        </svg>`,
    attributes: { title: 'Wrap for style' },
    state: (rte) => {
      return rte?.selection() && isValidTag(rte, 'SPAN')
        ? btnState.ACTIVE
        : btnState.ACTIVE;
    },
    // state: (rte) => {
    //   const element = rte.selection()?.anchorNode?.parentElement;
    //   if(element) return ["SPAN"].includes(element.tagName) ? btnState.ACTIVE : btnState.DISABLED;
    //   return btnState.ACTIVE;
    // },
    result: (rte) => {
      // !isValidTag(rte, 'SPAN') &&
      rte.insertHTML(`<span ${customElAttr}>${rte.selection()}</span>`, {
        select: true,
      });
    },
  });

  rte.add('sup', {
    icon: 'X<sup>$</sup>',
    attributes: { title: 'Superscript' },
    result: (rte) => rte.insertHTML(`<sup>${rte.selection()}</sup>`),
  });

  rte.add('sub', {
    icon: 'X<sub>$</sub>',
    attributes: { title: 'Subscript' },
    result: (rte) => rte.insertHTML(`<sub>${rte.selection()}</sub>`),
  });

  rte.add('doc', {
    icon: `<span class="fa fa-file-pdf-o"></span>`,
    attributes: { title: 'Doc-Link' },
    state: (rte) => {
      const element = rte.selection()?.anchorNode?.parentElement;
      if (element)
        return `${rte.selection()}`.length > 0
          ? btnState.ACTIVE
          : btnState.DISABLED;
      return btnState.ACTIVE;
    },
    result: (rte) => {
      const selectedText = `${rte.selection()}`;
      if (selectedText.length > 0) {
        return rte.insertHTML(wrapSelectionWithDocLink(selectedText), {
          select: true,
        });
      }
    },
  });

  const removeWrapFor = ['A', 'SPAN', 'SUP', 'SUB'];
  rte.add('remove-wrap', {
    icon: `<span class="fa fa-times"></span>`,
    attributes: { title: 'Remove selected text wrap' },
    state: (rte) => {
      const element = rte.selection()?.anchorNode?.parentElement;
      if (element)
        return removeWrapFor.includes(element.tagName)
          ? btnState.ACTIVE
          : btnState.DISABLED;
      return btnState.INACTIVE;
    },
    result: (rte) => {
      const element = rte.selection().anchorNode.parentElement;
      if (removeWrapFor.includes(element.tagName)) {
        const userConfirmation = window.confirm(
          "Are you sure you want to remove the selected text's wrap ?"
        );
        if (userConfirmation) {
          const elementText =
            rte.selection().anchorNode.parentElement.innerHTML;
          element.outerHTML = elementText;
        }
      }
    },
  });
};

export const previewHandler = (editor) => {
  let isRulerActive = false;
  // Content for Preview
  const navbar = $('#navbar');
  const mainContent = $('#main-content');
  const panelTopBar = $('#main-content > .navbar-light');

  editor.on('run:preview', () => {
    // This will be used to hide border
    editor.stopCommand('sw-visibility');
    // This will hide the sidebar view
    navbar.removeClass('sidebar');
    // This will make the main-content to be full width
    mainContent.removeClass('main-content');

    // This will hide top panel where we have added the button
    panelTopBar.addClass('d-none');
    console.log(panelTopBar);

    // This will hide ruler on preview
    isRulerActive = editor.Commands.isActive('ruler-visibility');
    if (isRulerActive) editor.stopCommand('ruler-visibility');
  });

  editor.on('stop:preview', () => {
    // This event is reverse of the above event.
    editor.runCommand('sw-visibility');
    navbar.addClass('sidebar');
    mainContent.addClass('main-content');
    panelTopBar.removeClass('d-none');

    if (isRulerActive) editor.runCommand('ruler-visibility');
  });
};

export const addDeviceManagerPanels = (editor, deviceList) => {
  const devices = deviceList.map((device) => ({
    deviceId: device.id,
    deviceName: device.name,
  }));
  const targettedDevice = editor.DeviceManager._config.default;

  const selectInputHTML = `
        <select id="select-device" class="form-control" ${devices.length === 1 ? 'disabled' : ''
    } >
            ${devices.map(({ deviceId, deviceName }) => {
      const deviceValue = deviceId;
      const deviceInfo =
        editor.DeviceManager.get(deviceValue).attributes;
      const deviceWidth = deviceInfo.width;
      const deviceHeight = deviceInfo.height;

      const deviceDimensions =
        deviceWidth !== '' && deviceHeight !== ''
          ? ` (${deviceWidth} x ${deviceHeight})`
          : '';

      return `
                <option
                    value="${deviceValue}"
                    ${deviceName === targettedDevice ||
          deviceId === targettedDevice
          ? 'selected'
          : ''
        }
                >
                    ${deviceName}${deviceDimensions}
                </option>
            `;
    })}            
        </select>
    `;
  $('.panel__devices').html(selectInputHTML);
  $('#select-device').on('change', (e) => {
    const selectedDevice = e.target.value;

    editor.setDevice(selectedDevice);
  });

  editor.on('device:select', (newDevice) => {
    // setTimeout(() => {
      editor.refresh();
      const zoom = newDevice.attributes.attributes.zoom;
      setZoom(editor, zoom);
    // }, 500);
  });
};

export const addPseudoSelectors = (editor) => {
  editor.on('component:deselected', () => {
    // CUA.i.
    editor.Selectors.setState('');
  });

  const selectorManager = editor.Selectors;
  const defaultStates = selectorManager
    .getStates()
    .map((state) => state.attributes);

  const afterPseudoState = ':after';
  const afterState = { name: afterPseudoState, label: 'After' };

  const beforePseudoState = ':before';
  const beforeState = { name: beforePseudoState, label: 'Before' };

  selectorManager.setStates([...defaultStates, afterState, beforeState]);

  function handleStyleChange(prop) {
    // CUA.ii.
    const selectedComponentClass = '.gjs-selected',
      cssRulesId = '#gjs-css-rules';

    const canvasBody = editor.Canvas.getBody();
    const cssRulesStyleBlock = canvasBody.querySelector(cssRulesId);
    for (const styleTag of cssRulesStyleBlock.children) {
      const styleTagToString = styleTag.innerHTML;
      if (styleTagToString.includes(selectedComponentClass))
        cssRulesStyleBlock.removeChild(styleTag);
    }
  }

  const contentProperty = {
    label: 'Content',
    property: 'content',
    type: 'base',
    default: `""`,
    full: true,
  };

  const contentPropertySector = 'extra';

  const addContentInput = () => {
    if (!editor.StyleManager.getProperty(contentPropertySector, 'content')) {
      // Step 1
      editor.StyleManager.addProperty(contentPropertySector, contentProperty);
    }
    const contentValue =
      editor.getSelectedToStyle().getStyle().content || contentProperty.default; // Step 2
    editor.getSelectedToStyle().addStyle({ content: contentValue }); // Step 3

    editor.on('style:property:update', handleStyleChange); // CUA.iii.
  };

  const removeContentInput = () => {
    editor.StyleManager.removeProperty(
      contentPropertySector,
      contentProperty.property
    ); // Step 4
    editor.off('style:property:update', handleStyleChange); // CUA.iii.
  };

  editor.on('selector:state', (selectedState) => {
    switch (selectedState) {
      case beforePseudoState:
      case afterPseudoState: {
        addContentInput();
        break;
      }

      default: {
        removeContentInput();
      }
    }
  });
};

export const toggleSidebar = (fromEditor) => {
  const sidebar = document.getElementById('navbar');
  const mainContent = document.getElementById('main-content');
  if (fromEditor) {
    sidebar.classList.remove('d-flex');
    sidebar.classList.add('d-none');
    mainContent.classList.remove('w-85', 'start-15');
  } else if (!sidebar.classList.contains('d-none')) {
    // sidebar.classList.remove("d-flex");
    // sidebar.classList.add("d-none");
    // mainContent.classList.remove("w-85", "start-15");
    // sidebar.classList.remove("d-flex");
    sidebar.classList.add('d-none');
    mainContent.classList.remove('w-85', 'start-15');
    mainContent.classList.add('w-100', 'start-0');
  } else {
    sidebar.classList.remove('d-none');
    // sidebar.classList.add("d-flex");
    mainContent.classList.remove('w-100', 'start-0');
    mainContent.classList.add('w-85', 'start-15');
    // editor.refresh();
  }
};

export const uploadAssets = async (
  e,
  editor,
  pathName,
  setMsg,
  setError,
  presentation
) => {
  const incorrectImages = [];
  try {
    const am = editor.AssetManager;
    const allPreviousAssets = am.getAll().models;
    let repeatAsset = false;
    let formData = new FormData();

    if (e.target.files.length !== 0) {
      // console.log("target file-");
      for (let fileData in e.target.files) {
        let isAssetAlreadyUploaded = allPreviousAssets.some((asset) => {
          return asset.get('src').endsWith(e.target.files[fileData].name);
        });

        if (isAssetAlreadyUploaded) {
          repeatAsset = true;
          if (
            !window.confirm(
              'An Asset with the same name is already present. Do you want to upload it?'
            )
          ) {
            e.target.value = '';
            return;
          }
        }
      }
      for (let fileData in e.target.files) {
        if (fileData !== 'length' && fileData !== 'item') {
          if (validateImageName(e.target.files[fileData].name)) formData.append('asset', e.target.files[fileData]);
          else incorrectImages.push(e.target.files[fileData].name);
        }
      }
    } else {
      // console.log("data-transfer file-");
      for (let fileData in e.dataTransfer.files) {
        if (fileData !== 'length' && fileData !== 'item') {
          if (validateImageName(e.dataTransfer.files[fileData].name)) formData.append('asset', e.dataTransfer.files[fileData]);
          else incorrectImages.push(e.dataTransfer.files[fileData].name);
        }
      }
    }

    const response = await postRequest(`assets/${pathName}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    document.querySelector('#gjs-am-uploadFile').value = null; // VERY IMP

    if (!response.data.isSuccess) {
      if (response.data.msg) {
        setError(true);
        setMsg(response.data.msg);
      }
    } else {
      am.add([...response.data.assetData, ...allPreviousAssets]);
      renderAssetManager(editor, pathName, presentation);
      await editor.store();
      if (repeatAsset) {
        // editor.store();
        window.location.reload();
      }
    }
  } catch (error) {
    setError(true);
    setMsg(error);
  } finally {
    if(incorrectImages.length > 0) {
      const incorrectImagesNames = incorrectImages.join("\n");
      window.alert(`Uploaded image must not contain any special characters.\nOnly hyphen (-), underscore (_) and period (.) are permitted.\nThe following images were not successfully uploaded as the names were invalid.\n${incorrectImagesNames}`);
    }
  }
};

const deleteAsset = async (
  editor,
  pathName,
  asset,
  setMsg,
  setError,
  presentation
) => {
  try {
    let apiPath = `assets/${pathName}/images/${asset.getFilename()}`;
    const response = await deleteRequest(apiPath);
    if (!response.data.isSuccess) {
      if (response.data.message) {
        setError(true);
        setMsg(response.data.message);
      }
    } else {
      let editorHTML = editor.getHtml();
      let editorCSS = editor.getCss();
      // remove deleted asset from html
      if (
        editorHTML.includes(asset.attributes.src) ||
        editorCSS.includes(asset.attributes.src)
      ) {
        editorCSS = editorCSS.replaceAll(asset.attributes.src, '');
        editor.setComponents(editorHTML.replaceAll(asset.attributes.src, ''));
        editor.addComponents('<style>' + editorCSS + '</style>');
      }
      renderAssetManager(editor, pathName, presentation);
      editor.store();
    }
  } catch (error) {
    setError(true);
    setMsg(error);
  }
};

export const handleAssetDelete = (
  editor,
  pathName,
  setMsg,
  setError,
  presentation
) => {
  editor.on('asset:remove', (asset) => {
    deleteAsset(editor, pathName, asset, setMsg, setError, presentation);
    editor.store(); // VERY IMP
  });
};

const checkIsScript = (model) => {
  return (
    model.is('script') ||
    model.parents().some((parentModel) => parentModel.is('script'))
  );
};

export const preserveComponentNames = (editor) => {
  function updateName(component) {
    if (checkIsScript(component)) return;
    
    const nameAttribute = 'data-gjs-name';
    const componentName = component.getName();
    component.addAttributes({ [nameAttribute]: componentName });
  }

  editor.on('component:add', updateName);
  editor.on('component:update:custom-name', updateName);
}

export const preserveComponentTypes = (editor) => {
  const componentTypeProperty = 'data-gjs-type';

  const updateType = (model) => {
    if (checkIsScript(model) || (!model.is('text') && !model.is('textnode')))
      return;

    const componentTypePropertyValue = model.get('type');

    // for those texts that don't have gjs-type: text but need to be shown as text
    if (model.is('textnode') && !model.parent().is('text')) {
      const modelParent = model.parent();
      modelParent.set({
        type: 'text',
        name: 'Text',
        editable: true,
      });
      modelParent.replaceWith(modelParent); // to simulate re-render of the text component
    } else {
      // for normal texts
      model.addAttributes({
        [componentTypeProperty]: componentTypePropertyValue,
      });
      model.set({ droppable: false }); // to prevent users from dropping additional elements inside text
    }
  };

  editor.on('component:add', updateType);
  editor.on('component:update', updateType);
};

export const addSelectRemoveStyleOption = (editor) => {
  editor.Components.addType('select', {
    model: {
      defaults: {
        'stylable-require': ['appearance'],
      },
    },
  });
};

export const addVeevaExternalLink = (editor) => {
  const veevaBlockId = 'Veeva-Link';
  const veevaLinkIdentifier = 'veeva-link';
  const presentationIDTraitName = 'presentation-id';
  const presentationIDTraitLabel = 'Presentation ID';
  const keyMessageTraitName = 'key-message-name';
  const keyMessageTraitLabel =
    "Key Message Name <small class='kmtraitcolor'>Enter .zip after name</small>";

  const traitOpts = [
    {
      type: 'text',
      name: 'id',
      label: 'ID',
      placeholder: 'Enter id...',
    },
    {
      type: 'text',
      name: presentationIDTraitName,
      label: presentationIDTraitLabel,
      placeholder: 'Enter Presentation ID...',
    },
    {
      type: 'text',
      name: keyMessageTraitName,
      label: keyMessageTraitLabel,
      placeholder: 'Enter .zip after name',
    },
  ];

  const veevaLinkDefaultStyles = {
    display: 'block',
    width: '100px',
    height: '100px',
  };

  editor.DomComponents.addType(veevaLinkIdentifier, {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.getAttribute('data-role') === veevaLinkIdentifier,

    extend: 'default',
    extendFn: ['init'],

    model: {
      defaults: {
        tagName: 'div',
        removable: true,
        draggable: true,
        droppable: true,
        copyable: true,
        resizable: true,
        attributes: {
          'data-role': veevaLinkIdentifier,
        },
        traits: traitOpts,
      },
    },
  });

  editor.BlockManager.add(veevaBlockId, {
    category: 'Components',
    media: renderThumbImage(veevaLogo),
    label: `${veevaBlockId}`,
    content: {
      type: veevaLinkIdentifier,
      style: veevaLinkDefaultStyles,
    },
  });

  // const veevaLinkComponents = editor.getWrapper().find(veevaLinkSelector);

  // for (const veevaLink of veevaLinkComponents) {
  //   traitOpts.forEach((traitObj) => veevaLink.addTrait(traitObj));
  // }

  // editor.on("block:drag:stop", (addedComponent, block) => {
  // editor.on("canvas:drop", (dataTransfer, addedComponent) => {
  //   const block = window.currentDraggedBlock;
  //   addedComponent = Array.isArray(addedComponent) ? addedComponent[0] : addedComponent;
  //   if (
  //     addedComponent &&
  //     block.getId() === veevaBlockId &&
  //     addedComponent.is(veevaLinkIdentifier)
  //   ) {
  //     traitOpts.forEach((traitObj) => addedComponent.addTrait(traitObj));
  //   }
  // });
};
export const addVAEemail = (editor) => {
  const veevaBlockId = 'VAE';
  const veevaLinkIdentifier = 'VAE';
  const DocIDTraitName = 'doc-id-vae';
  const DocIDTraitLabel = 'Doc ID VAE';

  const traitOpts = [
    {
      type: 'text',
      name: DocIDTraitName,
      label: DocIDTraitLabel,
      placeholder: 'Enter document ID VAE...',
    }
  ];

  const veevaLinkDefaultStyles = {
    display: 'block',
    width: '100px',
    height: '100px',
  };

  editor.DomComponents.addType(veevaLinkIdentifier, {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.getAttribute('data-role') === veevaLinkIdentifier,

    extend: 'default',
    extendFn: ['init'],

    model: {
      defaults: {
        tagName: 'div',
        removable: true,
        draggable: true,
        droppable: true,
        copyable: true,
        resizable: true,
        attributes: {
          'data-role': veevaLinkIdentifier,
        },
        traits: traitOpts,
      },
    },
  });

  editor.BlockManager.add(veevaBlockId, {
    category: 'Components',
    media: renderThumbImage(vaeLogo),
    label: `${veevaBlockId}`,
    content: {
      type: veevaLinkIdentifier,
      style: veevaLinkDefaultStyles,
    },
  });
};
// export const addModalTriggerElement = (editor) => {
//   const modalTriggerBlockId = "Modal-Trigger";
//   const modalTriggerIdentifier = "modal-trigger";

//   const modalTriggerTraitOpts = [
//     {
//       type: "text",
//       name: "id",
//       label: "ID",
//       placeholder: "Enter id...",
//     },
//     {
//       type: "text",
//       name: "data-target",
//       label: "Popup target Id",
//       placeholder: "Enter Popup target Id...",
//     },
//   ];

//   const modalTriggerStyles = {
//     display: "block",
//     width: "100px",
//     height: "100px",
//   };

//   editor.DomComponents.addType(modalTriggerIdentifier, {
//     isComponent: (el) =>
//       el.tagName === "DIV" &&
//       el.getAttribute("data-toggle") === "modal" &&
//       el.hasAttribute("data-target"),
//     extend: "default",
//     extendFn: ["init"],

//     model: {
//       defaults: {
//         tagName: "div",
//         removable: true, // Can't remove it
//         draggable: true, // Can't move it
//         droppable: true, // Can't drop any components inside this
//         copyable: true, // Disable copy/past
//         resizable: true,
//         attributes: {
//           "data-toggle": "modal",
//           "data-target": "",
//         },
//         traits: modalTriggerTraitOpts,
//       },
//     },
//   });

//   editor.BlockManager.add(modalTriggerBlockId, {
//     category: "Extra",
//     label: `<span class="fa fa-code"></span><div class="gjs-block-label">${modalTriggerBlockId}</div>`,
//     content: {
//       type: modalTriggerIdentifier,
//       style: modalTriggerStyles,
//     },
//   });
// };

export const addPosterTrait = (editor, pathName) => {
  const posterTraitOpts = {
    type: 'button',
    text: 'select poster Image',
    name: 'poster',
    label: 'poster',
    command: (editor) => {
      const am = editor.AssetManager;
      am.open({
        select(asset, complete) {
          const selected = editor.getSelected();
          if (selected && selected.is('video')) {
            let srcValue = asset
              .getSrc()
              .replace(`${API_HOST}assets/${pathName}`, '.');
            selected.addAttributes({ poster: srcValue });
            const selector =
              '#trait-container > div > div.gjs-trt-trait__wrp.gjs-trt-trait__wrp-poster > div > div.gjs-field-wrp.gjs-field-wrp--button > button';
            document.querySelector(selector).innerHTML = asset.getFilename();
            complete && am.close();
          }
        },
      });
    },
  };
  const videoComponents = editor.getWrapper().findType('video');
  for (const video of videoComponents) {
    video.removeTrait('poster');
    video.addTrait(posterTraitOpts);
  }
  // editor.on('block:drag:stop', (addedComponent, block) => {
  editor.on("canvas:drop", (dataTransfer, addedComponent) => {
    const block = window.currentDraggedBlock;
    addedComponent = Array.isArray(addedComponent) ? addedComponent[0] : addedComponent;
    if (addedComponent && block.id === 'video' && addedComponent.is('video')) {
      addedComponent.removeTrait('poster');
      addedComponent.addTrait(posterTraitOpts);
    }
  });

  editor.on('component:selected', (selectedComponent) => {
    if (selectedComponent && selectedComponent.is('video')) {
      if (selectedComponent.getAttributes().poster) {
        const assetName = selectedComponent
          .getAttributes()
          .poster.replace('./images/', '');
        selectedComponent.updateTrait('poster', { text: assetName });
      }
    }
  });
};

export const addWrapperBlock = (editor) => {
  const wrapperId = 'Parent-Wrapper';
  const wrapperLabel = 'Wrapper';
  const nextKeyMessageTraitName = 'next-key-message';
  const nextKeyMessageTraitLabel = `Next Key Message <small class='kmtraitcolor'>Enter .zip after name</small>`;
  const prevKeyMessageTraitName = 'prev-key-message';
  const prevKeyMessageTraitLabel = `Previous Key Message <small class='kmtraitcolor'>Enter .zip after name</small>`;
  const slideSequenceTraitName = 'slide-sequence';
  const slideSequenceTraitLabel = `Sequence Label`;

  const swipeupKeyMessageTraitName = 'swipeup-key-message';
  const swipeupKeyMessageTraitLabel = `Swipeup Key Message <small class='kmtraitcolor'>Enter .zip after name</small>`;
  const swipedownKeyMessageTraitName = 'swipedown-key-message';
  const swipedownKeyMessageTraitLabel = `Swipedown Key Message <small class='kmtraitcolor'>Enter .zip after name</small>`;

  const wrapperTraitOpts = [
    {
      type: 'text',
      name: 'id',
      label: 'ID',
      placeholder: 'Enter id...',
    },
    {
      type: 'text',
      name: prevKeyMessageTraitName,
      label: prevKeyMessageTraitLabel,
      placeholder: 'Enter previous key message name...',
      // attributes: {
      //   title: "Please enter .zip after key message name"
      // }
    },
    {
      type: 'text',
      name: nextKeyMessageTraitName,
      label: nextKeyMessageTraitLabel,
      placeholder: 'Enter next key message name...',
    },
    {
      type: 'text',
      name: slideSequenceTraitName,
      label: slideSequenceTraitLabel,
      placeholder: 'Like S1, S2...',
    },
    {
      type: 'text',
      name: swipeupKeyMessageTraitName,
      label: swipeupKeyMessageTraitLabel,
      placeholder: 'Enter next key message name...',
    },
    {
      type: 'text',
      name: swipedownKeyMessageTraitName,
      label: swipedownKeyMessageTraitLabel,
      placeholder: 'Enter next key message name...',
    },
  ];

  const wrapperStyles = {
    display: 'block',
    width: '100%',
    'min-height': '75px',
    padding: '10px',
  };

  // const wrapperComponents = editor.getWrapper().find("#wrapper");
  // if (wrapperComponents.length > 0) {
  //   const wrapperComponent = wrapperComponents[0];
  //   const swipeTraitOpts = wrapperTraitOpts.filter(
  //     (trait) => trait.name !== "id"
  //   );
  //   swipeTraitOpts.forEach((trait) => {
  //     wrapperComponent.getTrait(trait.name) || wrapperComponent.addTrait(trait);
  //   });
  // }

  editor.DomComponents.addType(wrapperId, {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
    (
      el.getAttribute('id') === 'wrapper' ||
      el.getAttribute('data-gjs-name') === wrapperLabel
    ),
    extend: 'default',
    extendFn: ['init'],
    model: {
      defaults: {
        tagName: 'div',
        draggable: true,
        droppable: true,
        attributes: {
          id: 'wrapper',
        },
        name: wrapperLabel,
        traits: wrapperTraitOpts,
        resizable: { ...rowResizableOpts, cr: 1 },
        copyable: false,
      },
    },
  });

  editor.BlockManager.add(wrapperId, {
    category: 'Basic',
    order: -1,
    media: `<span class="fa-regular fa-square-o"></span>`,
    label: `${wrapperLabel}`,
    content: {
      type: wrapperId,
      style: wrapperStyles,
    },
  });
};

const convertTemplateAssetsPathToKMPath = (pathName, content, pId, kmId, tId) => {
  let html = content['mycustom-html'];
  let css = content['mycustom-css'];
  let js = content['mycustom-js'] || null;
  let images = content['mycustom-assets'];

  const kmString = `/${pathName}`;
  const templateString = `/templates/${tId}`;

  const newHtml = html.replaceAll(templateString, kmString);
  const newCss = css.replaceAll(templateString, kmString);
  const newJs = js ? js.replaceAll(templateString, kmString) : null;
  const newImages = images.map((imageDetails) => {
    const newImageSrc = imageDetails.src.replaceAll(templateString, kmString);
    return {
      ...imageDetails,
      src: newImageSrc,
    };
  });

  const convertedContent = {
    'mycustom-html': newHtml,
    'mycustom-css': newCss,
    'mycustom-assets': newImages,
    'mycustom-js': newJs,
  };

  return convertedContent;
};

export const addTemplates = async (
  editor,
  config,
  pathName,
  setMsg,
  setError,
  presentation
) => {
  try {
    if (pathName.startsWith('presentations')) {
      const templatesResponse = await getRequest(`templates/list`, {
        headers: {
          'x-access-token': localStorage.getItem('token'),
          'x-refresh-token': localStorage.getItem('refreshToken'),
          changeOrigin: true,
        },
      });

      editor.clearDirtyCount();

      const templates = templatesResponse.data.templates;

      if (templates.length > 0) {
        templates.forEach((template) => {
          if (template.content) {
            const customBlockId = `template-${template._id}`;
            editor.BlockManager.add(customBlockId, {
              category: 'Templates',
              media: `<img draggable="false" class="block-template-thumb" alt="Template Thumb" src="${API_HOST}templates/${template._id}/thumb" />`,
              label: `${template.name}`,
              content: '<div></div>',
              attributes: {
                tId: template._id,
                tName: template.name
              }
          });
        }
      });
      
      // editor.on('block:drag:stop', (component, block) => {
        
          editor.on("canvas:drop", (dataTransfer, component) => {
            const block = window.currentDraggedBlock;
            component = Array.isArray(component) ? component[0] : component;

            const blockId = block.getId();
            const blockCategoryLabel = block.getCategoryLabel();
            const blockAttributes = block.get("attributes");
            const { tId, tName } = blockAttributes;
            const customBlockId = `template-${tId}`;

            if (
              blockId === customBlockId &&
              blockCategoryLabel === 'Templates' &&
              component
            ) {
              if(window.confirm(`Are you sure you want to use template:\n${tName}`)) {
                (async () => {
                  showLoader();
                  try {
                    const templateResponse = await getRequest(`templates/${tId}`);
                    const { template } = templateResponse.data;
  
                    const templateVideosResponse = await getRequest(
                      `assets/templates/${tId}/listVideos`
                    );
  
                    const videos = templateVideosResponse.data.isSuccess
                      ? templateVideosResponse.data.videos.keyMessage
                      : [];
  
                    const templateDocsResponse = await getRequest(
                      `assets/templates/${tId}/list-docs`
                    );
  
                    const docs = templateDocsResponse.data.isSuccess
                      ? templateDocsResponse.data.docs.keyMessage
                      : [];
  
                    const images = template.content['mycustom-assets']
                    .filter((imageDetails) => !imageDetails.src.endsWith("bg.jpg"))
                    .map(
                      (imageDetails) => {
                        const src = imageDetails.src;
                        const imageName = src.substring(
                          src.lastIndexOf('/') + 1,
                          src.length
                        );
                        return imageName;
                      }
                    );
  
                    const fonts = template.fonts;
  
                    //   pathName={`presentations/${presentationId}/key-messages/${kmId}`
                    const pathNameSplit = pathName.split('/');
                    const pId = pathNameSplit[1];
                    const kmId = pathNameSplit[pathNameSplit.length - 1];
  
                    const convertedContent = convertTemplateAssetsPathToKMPath(
                      pathName,
                      template.content,
                      pId,
                      kmId,
                      template._id
                    );
  
                    console.log(convertedContent['mycustom-js']);
                    const templateAsBlockRequestBody = {
                      pId,
                      kmId,
                      images,
                      fonts,
                      videos,
                      docs,
                      js: convertedContent['mycustom-js'],
                    };
  
                    const templateAsBlockResponse = await postRequest(
                      `templates/${template._id}/template-as-block`,
                      templateAsBlockRequestBody
                    );
  
                    const responseData = templateAsBlockResponse.data;
  
  
                    if (responseData.isSuccess) {
                      const assetManager = editor.AssetManager;
                      const allPreviousAssets = assetManager.getAll().models;
                      assetManager.add([
                        ...convertedContent['mycustom-assets'],
                        ...allPreviousAssets,
                      ]);
                      renderAssetManager(editor, pathName, presentation);
  
                      // add fonts to style manager
                      console.log(fonts);
                      for (const font of fonts) {
                        const [fontName, fontExtension] = font.split('.');
  
                        const fontFamilySettings =
                          editor.StyleManager.getProperty(
                            'typography',
                            'font-family'
                          );
  
                        const fontExists = [
                          ...fontFamilySettings.get('options'),
                        ].some((fontObj) => fontObj.name === fontName);
  
                        if (fontExists === false) {
                          fontFamilySettings.set('options', [
                            ...fontFamilySettings.get('options'),
                            { value: fontName, name: fontName },
                          ]);
                        }
  
                        let type =
                          fontExtension === 'ttf' ? 'truetype' : 'opentype';
  
                        const fontSrc = `${API_HOST}assets/${pathName}/fonts/${font}`;
                        // `@font-face{font-family:${fontName};src:url("${fontSrc}") format(${type});font-weight:normal;font-style:normal;font-display:fallback;}`;
                        let fontCss = `@font-face{font-family:${fontName};src:url("${fontSrc}") format(${type});font-weight:normal;font-style:normal;font-display:fallback;}`;
                        console.log("grapesjs")
                        editor.getCss().replaceAll(fontCss, '');
                        convertedContent['mycustom-css'] = convertedContent[
                          'mycustom-css'
                        ].replaceAll(fontCss, '');
  
                        const isFontFaceExist = editor
                          .getCss()
                          .includes(fontCss);
                        console.log('is font exists', isFontFaceExist);
  
                        if (!isFontFaceExist) {
                          console.log('font does not exist');
                          // editor.Css.addRules(fontCss);
                          convertedContent['mycustom-css'] += fontCss;
                        }
                      }
  
  
                      // let tempHtml = convertedContent['mycustom-html']
                      // tempHtml = tempHtml.replace(
                      //   '<body data-gjs-name="Body">',
                      //   `<div data-temp-id="${template._id}" class="${template._id}" data-gjs-name="Div">`
                      // )
                      // tempHtml = tempHtml.replace(`</body>`, `</div>`)
                      // console.log('rebody', tempHtml)
  
                      // convertedContent[
                      //   'mycustom-html'
                      // ] = `<body data-gjs-name="Body">${tempHtml}</body>`
                      console.log("changing km")
                      let tempHtml = responseData.data.content['mycustom-html'];
                      var regexp = /<script+.*>+.*<\/script>/g;
                      let scriptTagsArr = tempHtml.match(regexp)
  
                      tempHtml = tempHtml.replace(regexp, '')
                      if (scriptTagsArr != null) {
                        tempHtml = tempHtml + scriptTagsArr[0]
                      }
                      console.log('temphtml3 - ', tempHtml)
                      console.log("frontend html", convertedContent['mycustom-html'])
                      const modifiedComponent = component.replaceWith(
                        `${tempHtml}
                          <style>
                              ${responseData.data.content['mycustom-css']}
                          </style>`
                      );

                      if(config.DISABLE_TEMPLATE_ACTIVE_LINK) {
                        const wrapperComponent = editor.DomComponents.getWrapper().findType("Parent-Wrapper").at(0);

                        if (wrapperComponent) {
                          const wrapperSlideSequence = wrapperComponent.getAttributes()["slide-sequence"];
  
                          if (wrapperSlideSequence) {
                            const customVeevaLinksInTemplate = modifiedComponent.findType("custom-veeva-link");
    
                            for (const customVeevaLink of customVeevaLinksInTemplate) {
                              const customVeevaLinkSlideId = customVeevaLink.getAttributes()["data-slide"];
    
                              if(!customVeevaLinkSlideId || customVeevaLinkSlideId !== wrapperSlideSequence) continue;
                              
                              const customVeevaLinkStyles = customVeevaLink.getStyle();
                              customVeevaLink.setStyle({
                                ...customVeevaLinkStyles,
                                "pointer-events": "none"
                              });
                            }
                          }
                        }
                      }
                    }
                  } catch (err) {
                    setError(true);
                    setMsg(err);
                  }
                  hideLoader();
                })();
              } else {
                component.remove();
              }
            }
          });
          

        // TODO: search bar for templates code goes here
        // (() => {
        //   const templatesBlockOpts =
        //     editor.BlockManager.getCategories()._byId.Templates;
        //   if (templatesBlockOpts) {
        //     const searchComponent = `
        //             <div id="template-search">
        //                 <input
        //                     type="search"
        //                     id="template-search-input"
        //                     class="form-control form-control-sm mt-2"
        //                     placeholder="Enter template name..."
        //                 />
        //             </div>
        //         `;

        //     const templateCountComponent = `
        //             <div id="template-count" class="mx-5"></div>
        //         `;

        //     const { $ } = editor;
        //     const blockLabels = $('[data-template-label]');
        //     const $blocksElement = $(templatesBlockOpts.view.blocksEl);
        //     $blocksElement.prepend(templateCountComponent);
        //     $blocksElement.prepend(searchComponent);

        //     const updateCountOfVisibleTemplateBlocks = ({ initial }) => {
        //       let count = 0;
        //       blockLabels.each((index) => {
        //         const block = $(blockLabels[index]);
        //         const blockLabel = block.attr('data-template-label');
        //         const blockSelector = `.gjs-block.gjs-one-bg.gjs-four-color-h[title="${blockLabel}"]`;

        //         if (initial && $(blockSelector).length > 0) count++;
        //         else if ($(blockSelector).hasClass('d-flex')) count++;
        //       });

        //       $('#template-count').html(
        //         `${count} template${count === 1 ? '' : 's'}`
        //       );
        //     };

        //     updateCountOfVisibleTemplateBlocks({ initial: true });

        //     $('#template-search-input').on('input', (e) => {
        //       const searchValue = e.target.value.trim();

        //       if (searchValue === '') {
        //         blockLabels.each((index) => {
        //           const block = $(blockLabels[index]);
        //           const blockLabel = block.attr('data-template-label');
        //           const blockSelector = `.gjs-block.gjs-one-bg.gjs-four-color-h[title="${blockLabel}"]`;
        //           $(blockSelector).removeClass('d-none').addClass('d-flex');
        //         });
        //       } else {
        //         blockLabels.each((index) => {
        //           const block = $(blockLabels[index]);
        //           const blockLabel = block.attr('data-template-label');
        //           const blockSelector = `.gjs-block.gjs-one-bg.gjs-four-color-h[title="${blockLabel}"]`;
        //           if (
        //             !blockLabel
        //               .toLowerCase()
        //               .includes(searchValue.toLowerCase())
        //           ) {
        //             $(blockSelector).removeClass('d-flex').addClass('d-none');
        //           } else {
        //             $(blockSelector).removeClass('d-none').addClass('d-flex');
        //           }
        //         });
        //       }

        //       updateCountOfVisibleTemplateBlocks({ initial: false });
        //     });
        //   }
        // })();
      }
    }
  } catch (error) {
    setError(true);
    setMsg(error);
  }
};

export const customComponents = (editor) => {
  // modal(editor);
  table(editor, { containerId: '#gjs-editor' });
  bootstrap(editor, {
    blocks: {
      paragraph: false,
      card: false
    },
  });
};

export const loadAssetsFromDB = async (
  editor,
  pathName,
  keyMessage,
  presentation
) => {
  let sharedAssets = [];
  const keyMessageAssets =
    (keyMessage.content && keyMessage.content['mycustom-assets']) || [];

  if (!pathName.includes('templates') && !pathName.includes('components')) {
    try {
      // const pathUrl = `assets/${pathName.replace(`/key-messages/${kmId}`, "")}/shared-km`;
      const pathUrl = `assets/${pathName}/shared-km`;
      const { data } = await getRequest(pathUrl);

      sharedAssets = data.assets.map((asset) => ({ ...asset, shared: true }));
    } catch (err) {
      console.log(err);
      sharedAssets = [];
    }
  }

  const allAssets = [...sharedAssets, ...keyMessageAssets];

  if (editor.AssetManager != null && editor.AssetManager.add) {
    const am = editor.AssetManager;
    am.add([...allAssets]);
    renderAssetManager(editor, pathName, presentation);
  }

  // setTimeout(() => {
  //   let categories = editor.BlockManager.getCategories();
  //   categories.each((category) => {
  //     category.set("open", false);
  //   });
  // }, 500);
  localStorage.setItem('key-message-name', keyMessage.name);
};

export const showAlertOnError = (editor, setMSg, setError) => {
  editor.on('storage:error:store', () => {
    setError(true);
    setMSg('Internal server error!! Content not saved');
  });
};

export const autoCloseCategories = (editor) => {
  const blockTitle = document.querySelectorAll('.gjs-title');
  const styleTitle = document.querySelectorAll('.gjs-sm-sector-title');

  blockTitle.forEach((title) => {
    title.addEventListener('click', () => {
      let category = title.textContent.trim();
      if (category === 'Forms') {
        category = 'forms';
      }
      editor.BlockManager.getCategories().forEach((cat) => {
        if (cat.id !== category) {
          cat.set('open', false);
        }
      });
    });
  });

  styleTitle.forEach((title) => {
    title.addEventListener('click', () => {
      const category = title.textContent.trim().toLowerCase();
      editor.StyleManager.getSectors().forEach((style) => {
        if (style.id !== category) {
          style.set('open', false);
        }
      });
    });
  });
};

export const handleHamburgerClick = (editor) => {
  $(".btn[title='Toggle sidebar']").on('click', () => {
    console.log('triggered');
    setTimeout(() => {
      editor.refresh();
    }, 10);
  });
};

export const closeAllCategoriesByDefault = (editor) => {
  // setTimeout(() => {
    if (editor.BlockManager) {
      let categories = editor.BlockManager.getCategories();
      categories.each((category) => {
        category.set('open', false);
      });
    }
  // }, 1000);
};

export const loadAllPlugins = (structure, pId, kmId) => {
  let scripts = [],
    styles = [];
  const { plugins } = structure;
  plugins.js.map((js) =>
    scripts.push(`${API_HOST}assets/imports/${pId}/key-messages/${kmId}/${js}`)
  );
  // scripts.push(
  //   `${API_HOST}assets/imports/${pId}/key-messages/${kmId}/${structure.js}`
  // );
  plugins.css.map((css) =>
    styles.push(`${API_HOST}assets/imports/${pId}/key-messages/${kmId}/${css}`)
  );

  return [styles, scripts];
};

export const storageSetting = (contentId, pathName) => {
  return {
    type: 'remote',
    stepsBeforeSave: 1000,
    autoload: false,
    autosave: true,
    options: {
      remote: {
        onStore: (data, editor) => {
          const assetsForKm = data.assets.filter((asset) =>
            asset.src.includes(contentId)
          );
          return {
            'mycustom-html': editor.getHtml({ data }),
            // "mycustom-css": editor.getCss({ data }),
            'mycustom-css': editor.getCss({ ...data, keepUnusedStyles: true }),
            'mycustom-assets': assetsForKm,
          };
        },
        onLoad: (result) => result.data,
        urlStore: `${API_HOST}${pathName}/content`,
      },
    },
  };
};

export const removeCloseButtonForSharedAssets = (editor) => {
  //  hide close button for shared assets
  const am = editor.AssetManager;
  const allAssets = am.getAll().models;
  const sharedAssets = allAssets.filter(
    (asset) => asset.attributes.shared === true
  );
  sharedAssets.forEach((sharedAsset) => {
    if (sharedAsset.view) {
      const $sharedAssetEl = sharedAsset.view.$el;
      const closeButtonSelector = '.gjs-am-close';
      const gjsMetaElSelector = '.gjs-am-meta';

      const sharedBadgeHTML = `<div><span class="badge bg-primary" title="This image is a shared asset">Shared</span></div>`;

      const $closeButton = $sharedAssetEl.find(closeButtonSelector);
      if ($closeButton.length > 0) {
        $closeButton.replaceWith('');
        $sharedAssetEl.find(gjsMetaElSelector).append(sharedBadgeHTML);
      }
    }
  });
};

export const removeCloseButtonForImportedAssets = (
  editor,
  pathName,
  presentation
) => {
  //  hide close button for shared assets
  const am = editor.AssetManager;
  const allAssets = am.getAll().models;
  const nonMainFolderAssets = allAssets.filter((asset) => {
    let src = asset.get('src').replace(`${API_HOST}assets/${pathName}/`, '');
    const condition = !src.startsWith(`${presentation.structure.images[0]}`);
    return condition;
  });
  nonMainFolderAssets.forEach((nonMainFolderAsset) => {
    if (nonMainFolderAsset.view) {
      const $nonMainFolderAssetEl = nonMainFolderAsset.view.$el;
      const closeButtonSelector = '.gjs-am-close';
      const gjsMetaElSelector = '.gjs-am-meta';

      const importBadgeHTML = `<div><span class="badge bg-primary" title="This image is a non deletable asset">Non deletable</span></div>`;

      const $closeButton = $nonMainFolderAssetEl.find(closeButtonSelector);
      if ($closeButton.length > 0) {
        $closeButton.replaceWith('');
        $nonMainFolderAssetEl.find(gjsMetaElSelector).append(importBadgeHTML);
      }
    }
  });
};

export const renderAssetManager = (
  editor,
  pathName = null,
  presentation = null
) => {
  editor.AssetManager.render();
  removeCloseButtonForSharedAssets(editor);
  if (pathName && presentation && pathName.startsWith('imports')) {
    removeCloseButtonForImportedAssets(editor, pathName, presentation);
  }
};

export const removeBackgroundInputForBody = (editor) => {
  const bodyType = 'wrapper';
  editor.on('component:selected', (component) => {
    const decorationsSectorEl = document.querySelector(
      '.gjs-sm-sector.gjs-sm-sector__decorations'
    );
    if (component.is(bodyType)) {
      decorationsSectorEl.style.display = 'none';
    } else {
      decorationsSectorEl.style.display = '';
    }
  });
};

export const getExternalStyles = (pathName, presentation, keyMessage, kmId, styles) => {
  var finalStyles = styles;
  if (presentation.sharedFolder === 'Yes') {
    const globalCSSHrefShared = `${API_HOST}assets/${pathName}/shared/css/style.css`;
    finalStyles = [...finalStyles, globalCSSHrefShared];
  }
  if (presentation.mctsFlow === 'Yes') {
    // alert("presentation brand externalstyles : ", presentation.sharedFolder)
    const otherStyleFiles_shared = `${API_HOST}assets/${pathName}/shared/css/themes/${presentation.mctsBrand}/style.css`;
    const otherStyleFiles = `${API_HOST}assets/${pathName}/shared/css/framework-menu.css`;
    finalStyles = [...finalStyles, otherStyleFiles, otherStyleFiles_shared];
  }
  return finalStyles;
};

export const showUnsavedChangesNum = (editor) => {
  const changesEl = document.querySelector('#show-changes-count');

  const showChangesUnsaved = (unsavedChangesCount) => {
    changesEl.className = 'fa fa-exclamation-circle fa-lg';
    changesEl.setAttribute(
      'title',
      `You have ${unsavedChangesCount} change${unsavedChangesCount === 1 ? '' : 's'
      } unsaved.`
    );
    changesEl.style.color = 'red';
  };

  const showChangesSaved = () => {
    changesEl.className = 'fa fa-check-circle fa-lg';
    changesEl.setAttribute('title', `All changes are saved.`);
    changesEl.style.color = 'green';
  };

  showChangesSaved();

  const updateChangesCount = () => {
    const unsavedChangesCount = editor.getDirtyCount();
    // console.log(unsavedChangesCount);
    if (unsavedChangesCount > 0) showChangesUnsaved(unsavedChangesCount);
    else showChangesSaved();
  };

  editor.on("update", updateChangesCount);

  editor.on("storage:end:store", () => {
    setTimeout(() => {
      updateChangesCount();
    }, 10);
  });
  // editor.on('update', () => {
  //   const unsavedChangesCount = editor.getDirtyCount();
  //   if (unsavedChangesCount > 0) showChangesUnsaved(unsavedChangesCount);
  //   else showChangesSaved();
  // });
};

export const addDocLink = (editor) => {
  const docLinkBlockId = 'Doc-Link';
  const docLinkIdentifier = 'Doc-Link';

  const docLinkTraitOpts = [
    {
      type: 'text',
      name: 'id',
      label: 'ID',
      placeholder: 'Enter id...',
    },
    {
      type: 'select',
      name: 'target',
      label: 'Target',
      options: [
        { id: '', name: 'This tab' },
        { id: '_blank', name: 'New Tab' },
      ],
    },
    {
      type: 'button',
      text: 'Change PDF',
      label: false,
      full: true,
      command: (editor) => {
        const currentSelectedComponent = editor.getSelected();
        return editor.runCommand('docs', {
          docComponent: currentSelectedComponent,
        });
      },
    },
  ];

  const docLinkDefaultStyles = {
    display: 'inline-block',
    width: '100px',
    height: '100px',
  };

  editor.DomComponents.addType(docLinkIdentifier, {
    isComponent: (el) =>
      el.tagName === 'A' && el.getAttribute('data-role') === docLinkIdentifier,

    extend: 'text',
    extendFn: ['init'],

    model: {
      defaults: {
        tagName: 'a',
        editable: true,
        removable: true, // Can't remove it
        draggable: true, // Can't move it
        droppable: true, // Can't drop any components inside this
        copyable: true, // Disable copy/past
        resizable: true,
        attributes: {
          'data-role': docLinkIdentifier,
          href: '',
        },
        traits: docLinkTraitOpts,
      },

      init() {
        this.handlePDFChange();
        this.on('change:attributes:href', this.handlePDFChange);
      },

      handlePDFChange() {
        const hrefAttribute = this.getAttributes()['href'];

        let pdfName = null;
        if (!hrefAttribute || hrefAttribute === '') pdfName = null;
        else {
          const pdfNameArray = hrefAttribute.split('/');
          pdfName = pdfNameArray[pdfNameArray.length - 1];
        }

        const allTraits = this.getTraits();
        const changeDocBtnTrait = allTraits[allTraits.length - 1];
        changeDocBtnTrait.set({
          label: pdfName || false,
        });
      },
    },
  });

  editor.BlockManager.add(docLinkBlockId, {
    category: 'Components',
    media: `<span class="fa fa-file-pdf-o"></span>`,
    label: `${docLinkBlockId}`,
    content: {
      type: docLinkIdentifier,
      style: docLinkDefaultStyles,
    },
  });

  // editor.on('block:drag:stop', (addedComponent, block) => {

  editor.on("canvas:drop", (dataTransfer, addedComponent) => {
    const block = window.currentDraggedBlock;
    addedComponent = Array.isArray(addedComponent) ? addedComponent[0] : addedComponent;
    if (
      addedComponent &&
      block.getId() === docLinkBlockId &&
      addedComponent.is(docLinkIdentifier)
    ) {
      editor.runCommand('docs', { docComponent: addedComponent });
    }
  });
};

export const toggleAbsoluteDragMode = (editor) => {
  const dragModePanelBtn = editor.Panels.getButton(
    'editor-actions',
    'dragModePopup'
  );
  const transformLabel = 'DM: T',
    absoluteLabel = 'DM: Ab',
    transformTitleAttribute = 'Current Drag Mode: Transform',
    absoluteTitleAttribute = 'Current Drag Mode: Absolute';

  // const handleDropAbsoluteComponent = (addedComponent, block) => {
  const handleDropAbsoluteComponent = (dataTransfer, addedComponent) => {
    // const block = window.currentDraggedBlock;
    addedComponent = Array.isArray(addedComponent) ? addedComponent[0] : addedComponent;
    
    if (!addedComponent) return;

    if (!addedComponent.is('custom-popup')) {
      const popupComponents = editor
        .getWrapper()
        .find(`[data-role="custom-popup"]`);
      if (popupComponents.length > 0) {
        let popupToAppend = null;
        for (const popup of popupComponents) {
          const popupStyles = popup.getStyle();
          const displayValue = popupStyles.display;
          if (displayValue !== 'none') {
            popupToAppend = popup;
          }
        }
        if (popupToAppend) {
          const popupToAppendContent = popupToAppend.find(
            `[data-role="popup-content"]`
          )[0];
          addedComponent.move(popupToAppendContent);
          return;
        }
      }
    }

    if(!addedComponent.is("Parent-Wrapper")) {
      const wrapperComponent = editor.getWrapper().find('#wrapper');
      if (wrapperComponent.length > 0) {
        addedComponent.move(wrapperComponent[0]);
      }
    }
  };

  const setAbsoluteDragMode = (editor) => {
    editor.setDragMode('absolute');

    // editor.on('block:drag:stop', handleDropAbsoluteComponent);
    editor.on('canvas:drop', handleDropAbsoluteComponent);

    dragModePanelBtn.set({
      label: absoluteLabel,
      attributes: {
        title: absoluteTitleAttribute,
      },
    });
  };

  const setTranslateDragMode = (editor) => {
    editor.setDragMode('translate');

    // editor.off('block:drag:stop', handleDropAbsoluteComponent);
    editor.off('canvas:drop', handleDropAbsoluteComponent);

    dragModePanelBtn.set({
      label: transformLabel,
      attributes: {
        title: transformTitleAttribute,
      },
    });
  };
  editor.Commands.add('drag-mode', {
    run: setAbsoluteDragMode,
    stop: setTranslateDragMode,
  });

  editor.on('load', () => {
    if (editor.editor.get('dmode') === 'absolute') {
      editor.runCommand('drag-mode');
    }
  });
};

export const moveComponentsByKeys = (editor) => {
  const keyMaps = editor.Keymaps;
  const keyMapUpId = 'ns:move-comp-up';
  const keyMapDownId = 'ns:move-comp-down';
  const keyMapLeftId = 'ns:move-comp-left';
  const keyMapRightId = 'ns:move-comp-right';
  const keyMapUpButton = 'ctrl+up';
  const keyMapDownButton = 'ctrl+down';
  const keyMapLeftButton = 'ctrl+left';
  const keyMapRightButton = 'ctrl+right';

  const moveHandler = ({ editor, keyId }) => {
    const direction = keyId.replace('ns:move-comp-', '');

    const isCurrentDragModeAbsolute = editor.Commands.isActive('drag-mode');

    const selectedComponent = editor.getSelected();
    const componentStyle = selectedComponent.getStyle();

    const moveComponentWithPositionProperty = () => {
      let newStyleConfig = {
        up: {
          property: 'top',
          value: -1,
        },
        down: {
          property: 'top',
          value: 1,
        },
        left: {
          property: 'left',
          value: -1,
        },
        right: {
          property: 'left',
          value: 1,
        },
      };

      const propertyToUpdate = newStyleConfig[direction].property;
      let existingPropertyValue = 0;
      if (componentStyle[propertyToUpdate]) {
        const propertyValueInString = componentStyle[propertyToUpdate];
        existingPropertyValue = parseFloat(propertyValueInString);
      }

      const updatedPropertyValue =
        existingPropertyValue + newStyleConfig[direction].value;

      selectedComponent.setStyle({
        ...componentStyle,
        position: componentStyle['position'] || 'absolute',
        [propertyToUpdate]: `${updatedPropertyValue}px`,
      });
    };

    const moveComponentWithTranslateProperty = () => {
      const propertyToUpdate = 'transform';
      const existingPropertyValues = { x: 0, y: 0 };
      if (componentStyle[propertyToUpdate]) {
        const existingPropertyValueString = componentStyle[propertyToUpdate];
        existingPropertyValues.x = parseFloat(
          existingPropertyValueString.slice(
            existingPropertyValueString.indexOf('(') + 1,
            existingPropertyValueString.indexOf(')')
          )
        );
        existingPropertyValues.y = parseFloat(
          existingPropertyValueString.slice(
            existingPropertyValueString.lastIndexOf('(') + 1,
            existingPropertyValueString.lastIndexOf(')')
          )
        );
      }

      let newStyleConfig = {
        up: {
          property: 'y',
          value: -1,
        },
        down: {
          property: 'y',
          value: 1,
        },
        left: {
          property: 'x',
          value: -1,
        },
        right: {
          property: 'x',
          value: 1,
        },
      };

      const valueToChange = newStyleConfig[direction].property;
      const valueChangeDifference = newStyleConfig[direction].value;
      const updatedValues = {
        ...existingPropertyValues,
        [valueToChange]:
          existingPropertyValues[valueToChange] + valueChangeDifference,
      };

      selectedComponent.setStyle({
        ...componentStyle,
        [propertyToUpdate]: `translateX(${updatedValues.x}px) translateY(${updatedValues.y}px)`,
      });
    };

    if (isCurrentDragModeAbsolute) {
      moveComponentWithPositionProperty();
    } else {
      moveComponentWithTranslateProperty();
    }
  };

  keyMaps.add(keyMapUpId, keyMapUpButton, (editor) =>
    moveHandler({ editor, keyId: keyMapUpId })
  );
  keyMaps.add(keyMapDownId, keyMapDownButton, (editor) =>
    moveHandler({ editor, keyId: keyMapDownId })
  );
  keyMaps.add(keyMapLeftId, keyMapLeftButton, (editor) =>
    moveHandler({ editor, keyId: keyMapLeftId })
  );
  keyMaps.add(keyMapRightId, keyMapRightButton, (editor) =>
    moveHandler({ editor, keyId: keyMapRightId })
  );
};

export const addDiv = (editor) => {
  const divComponentId = 'Div';
  const divBlockId = 'Div';

  editor.DomComponents.addType(divComponentId, {
    isComponent: (el) => {
      return (
        el.tagName === 'DIV' &&
        el.getAttribute('data-gjs-type') === divComponentId &&
        el.getAttribute('data-gjs-name') === divComponentId
      );
    },

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        removable: true,
        draggable: true,
        droppable: true,
        copyable: true,
        resizable: true,
      },
    },
  });

  const divDefaultStyles = {
    display: 'block',
    width: '100%',
    height: '100px',
  };

  editor.BlockManager.add(divBlockId, {
    category: 'Basic',
    media: `<span class="fa-regular fa-square-o"></span>`,
    label: `${divBlockId}`,
    content: {
      type: divComponentId,
      style: divDefaultStyles,
    },
  });
};

export const linkAdjust = (editor) => {
  editor.BlockManager.get('link').get('content').style = {
    display: 'inline-block',
  };
};

export const Resize = (editor) => {
  const addResizableToComponent = (componentType) => {
    editor.DomComponents.addType(componentType, {
      model: {
        defaults: {
          resizable: true,
        },
      },
    });
  };

  const componentTypes = editor.DomComponents.getTypes().map(
    (component) => component.id
  );
  componentTypes.forEach(addResizableToComponent);

  editor.on('component:type:add', (modelDeclaration) => {
    const modelType = modelDeclaration.id;
    addResizableToComponent(modelType);
  });

  // editor.getWrapper().onAll((component) => {
  //   component.set("resizable", true);
  // });

  // editor.on("component:add", (component) => {
  //   component.set("resizable", true);
  // });
};

export const removeGjsSelectedClass = (editor) => {
  const gjsSelectedClass = '.gjs-selected';
  editor.on('update', () => {
    const cssComposer = editor.CssComposer;
    const gjsSelectedRule = cssComposer.getRule(gjsSelectedClass);
    if (gjsSelectedRule) cssComposer.remove(gjsSelectedRule);
  });
};

export const addComponentModel = (
  editor,
  { pathName, pId, kmId, setMsg, setError, userStore }
) => {
  if (!pathName.startsWith('presentations') || !userStore?.config?.TAB_COMPONENTS)
    return null;

  editor.DomComponents.addType('component', {
    isComponent: (el) => el.tagName === 'DIV' && el.hasAttribute('data-rc-id'),

    extend: 'default',
    extendFn: ['init'],

    model: {
      defaults: {
        tagName: 'div',
        editable: false,
        removable: true,
        draggable: true,
        droppable: false,
        copyable: true,
        resizable: true,
      },
    },
    view: {
      async onRender({ el }) {
        const rcId = el.getAttribute('data-rc-id');
        if (!rcId || rcId === '') return null;

        const rcAPI = `presentations/${pId}/key-messages/${kmId}/components/${rcId}/content`;
        try {
          const { data } = await getRequest(rcAPI);
          if (data.isSuccess) {
            const htmlContent = data.content['mycustom-html'];
            const cssContent = data.content['mycustom-css'];

            const rcContent = `${htmlContent}<style>${cssContent}</style>`;

            el.innerHTML = rcContent;
          }
        } catch (err) {
          console.log(err);
        }
      },
    },
  });
};

export const addComponents = async ({
  editor,
  pathName,
  pId,
  kmId,
  setMsg,
  setError,
  userStore,
}) => {
  if (!pathName.startsWith('presentations') || !userStore?.config?.TAB_COMPONENTS)
    return null;

  editor.Panels.addButton('util-actions', {
    id: 'component-repository',
    className: 'fa fa-puzzle-piece',
    command: () =>
      createComponentManager({ editor, pathName, pId, kmId, setMsg, setError }),
    attributes: {
      title: 'Component Repository',
    },
  });

  // update key message components blocks on editor load
  const { data } = await getRequest(`${pathName}/components`);
  if (data.isSuccess) {
    const { components } = data;
    for (const component of components) {
      const { _id: rcId, name } = component;
      const customRcId = `rc-${rcId}`;
      editor.BlockManager.add(customRcId, {
        category: 'Components',
        media: `<span class="fa fa-code"></span>`,
        label: `${name}`,
        content: {
          type: 'component',
          attributes: {
            'data-rc-id': rcId,
          },
        },
      });
    }
  } else {
    console.log(data);
  }
};

export const hideToolbarOnStyleClick = (editor) => {
  const $stylesContainer = $('#styles-container');
  const gjsToolbar = editor.Canvas.getToolbarEl();
  const editorCanvas = editor.Canvas.getBody();

  $stylesContainer.on('click', (e) => {
    gjsToolbar.style.display = 'none';
  });

  editorCanvas.addEventListener('click', () => {
    if (gjsToolbar.style.display === 'none') gjsToolbar.style.display = 'block';
  });
};

export const avoidMultipleWrapper = (editor, { setMsg, setError }) => {
  const refreshLayerManager = () => {
    const layerContainer = document.querySelector('#layers-container');
    editor.LayerManager.destroy();
    const newLayers = editor.LayerManager.render();
    layerContainer.append(newLayers);
  };

  editor.on('component:add', (model) => {
    const wrapperType = 'Parent-Wrapper';
    if (model.is(wrapperType)) {
      const allWrapperComponents = editor.getWrapper().findType(wrapperType);
      if (allWrapperComponents.length > 1) {
        alert('Only one Wrapper Component is allowed');
        const wrappersToRemove = allWrapperComponents.filter(
          (component) => component.getAttributes().id !== 'wrapper'
        );
        if (wrappersToRemove.length < allWrapperComponents.length) {
          for (const wrapper of wrappersToRemove) {
            wrapper.remove();
          }
        }
        refreshLayerManager();
      }
    }
  });
};

export const loadScripts = async (editor, scripts, $) => {
  for (const script of scripts) {
    await new Promise((resolve, reject) => {
      const scriptTag = document.createElement('script');
      scriptTag.setAttribute('src', script);
      scriptTag.setAttribute('fetchpriority', 'high');
      scriptTag.addEventListener('load', resolve);

      if (editor.Canvas?.getDocument()) {
        // try {
        editor.Canvas.getDocument().head.appendChild(scriptTag);
        // } catch (err) {
        //   console.log(err);
        // }
      }
    });
  }

  if (editor.Canvas?.getFrameEl()) {
    const loadEvent = new Event('load');
    editor.Canvas.getFrameEl().contentWindow.dispatchEvent(loadEvent);
  }

  // let totalScriptContent = "";
  // for(const script of scripts) {
  //   const response = await fetch(script);
  //   let scriptContent = await response.text();
  //   scriptContent = scriptContent.replace(/\s+/g, " ").trim();
  //   // console.log(script);
  //   // console.log(scriptContent);
  //   // totalScriptContent += `/*--${script}--*/\n${scriptContent}\n/*-----------*/\n\n`;
  //   totalScriptContent += `/*--${script}--*/${scriptContent}/*-----------*/`;
  // }

  // // console.log(totalScriptContent);
  // const scriptTag = document.createElement("script");
  // scriptTag.innerText = `${totalScriptContent}`;
  // if (editor.Canvas?.getDocument()) {
  //   editor.Canvas.getDocument().head.appendChild(scriptTag);
  // }

  // for (const script of scripts) {
  //   await new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //       const scriptTag = document.createElement("script");
  //       scriptTag.setAttribute("src", script);
  //       scriptTag.setAttribute("fetchpriority", "high");
  //       if (editor.Canvas?.getDocument()) {
  //         editor.Canvas.getDocument().head.appendChild(scriptTag);
  //       }
  //       resolve();
  //     }, 100);
  //   });
  // }
};

export const addNthchildSelector = (editor) => {
  const selectorManager = editor.SelectorManager;
  const defaultStates = selectorManager
    .getStates()
    .map((state) => state.attributes);

  const nthChildProperty = 'nth-child';
  const nthChildState = { name: nthChildProperty, label: 'nth-child' };

  selectorManager.setStates([...defaultStates, nthChildState]);

  const addnthValueInput = () => {
    nthChildPopup(editor);
  };

  const removeNthValueInput = () => { };

  editor.on('selector:state', (selectedState) => {
    switch (selectedState) {
      case nthChildProperty: {
        addnthValueInput();
        break;
      }

      default: {
        removeNthValueInput();
      }
    }
  });
};

export const addMCTSJs = async (editor, pathName, pId, kmId, keyMessage) => {
  if (!keyMessage || keyMessage?.mctsFlow === 'No') return;

  if (editor.Canvas) {
    const scriptsArray = [
      `${API_HOST}assets/${pathName}/shared/js/script.js`,
      `${API_HOST}assets/${pathName}/js/script.js`,
      `${API_HOST}assets/${pathName}/shared/plugins/framework.js`,
    ];
    for (const script of scriptsArray) {
      await new Promise((resolve, reject) => {
        setTimeout(() => {
          const frameworkJsScript = script;
          const scriptTag = document.createElement('script');
          scriptTag.setAttribute('src', frameworkJsScript);
          scriptTag.setAttribute('fetchpriority', 'high');
          editor.Canvas.getDocument().head.appendChild(scriptTag);
          resolve();
        }, 50);
      });
    }
  }
};

export const removeTextDefaultPadding = (editor, { config }) => {
  if (config.KEEP_DEFAULT_TEXT_PADDING) return;

  // editor.on('block:drag:stop', (model, block) => {
  editor.on("canvas:drop", (dataTransfer, model) => {
    const block = window.currentDraggedBlock;
    model = Array.isArray(model) ? model[0] : model;

    if (model.is('text') && block.getId() === 'text') {
      const defaultStyle = model.getStyle();
      const { padding, ...newStyle } = defaultStyle;
      model.setStyle(newStyle);
    }
  });
};

export const addParentChildSelectorsSupport = (editor) => {
  const componentNameSpan = document.querySelector(
    '#selector-container .gjs-clm-sels-info'
  );
  const hideComponentNameSpan = () =>
    (componentNameSpan.style.display = 'none');
  const showComponentNameSpan = () =>
    (componentNameSpan.style.display = 'block');

  const selectorChoiceDiv = document.querySelector('#selector-choice');
  const selectorSelectChoice = `
    <label
      id="selector-label"
      class="form-label"
    >
      Choose Selector:
    </label>
    <select
      id="selector-select"
      class="form-control form-control-sm"
      data-value="default"
    >
      <option selected value='default'>Default</option>
    </select>
  `;

  selectorChoiceDiv.innerHTML = selectorSelectChoice;

  const selectorSelect = selectorChoiceDiv.querySelector('#selector-select');

  let lastSelected = null,
    lastSelector = null;
  const updateSelectorSelectOptions = (rules, selectedElementId) => {
    let options = "<option value='default'>Default</option>";

    if (selectedElementId) {
      if (
        rules.filter(
          (rule) => rule.selectorsToString() === `#${selectedElementId}`
        ).length === 0
      ) {
        options += `<option value='#${selectedElementId}'>#${selectedElementId}</option>`;
      }

      const optionsArray = rules.map((rule) => {
        const ruleSelectorString = rule.selectorsToString();
        return `<option value="${ruleSelectorString}">${ruleSelectorString}</option>`;
      });

      options += optionsArray.join('');
    }

    selectorSelect.innerHTML = options;

    if (
      selectedElementId &&
      lastSelected &&
      lastSelected === editor.getSelected().getId()
    ) {
      selectorSelect.value = lastSelector;
      selectorSelect.dataset.value = lastSelector;
    } else {
      selectorSelect.value = 'default';
      selectorSelect.dataset.value = 'default';
    }

    // selectorSelect.value = selectedElementId ? lastSelected : "default";
    // selectorSelect.dataset.value = selectedElementId ? lastSelected : "default";
  };

  const updateSelectedElementRules = () => {
    const selectedElement = editor.getSelected();

    if (!selectedElement || selectedElement.is('wrapper')) {
      // ignore if selectedElement doesn't exist or selectedElement is body tag
      updateSelectorSelectOptions([], null);
      showComponentNameSpan();
      lastSelected = null;
      lastSelector = null;
      return;
    }
    const getElement = (selector) => editor.getWrapper().find(selector);
    const selectedElementHTML = selectedElement.toHTML({ withProps: true });
    const matchingRules = editor.CssComposer.getRules().filter((rule) => {
      const selectorString = rule.selectorsToString();
      if (['*', ''].includes(selectorString.trim())) return false;

      if (rule.getAtRule().startsWith('@keyframes')) return false; // ignore @keyframes css

      if (Object.keys(rule.get('style')).length === 0) return false; // ignore if no styles exist for the rule

      const thisRuleElements = getElement(rule.selectorsToString());
      if (thisRuleElements.length === 0) return false;

      // compare css rule elements with selected element and see if at least one matches
      return thisRuleElements.some(
        (ruleElement) =>
          selectedElementHTML === ruleElement.toHTML({ withProps: true })
      );
    });

    updateSelectorSelectOptions(matchingRules, selectedElement.getId());
    // showComponentNameSpan();
  };

  selectorSelect.addEventListener('input', (e) => {
    e.currentTarget.dataset.value = e.currentTarget.value;

    const newSelectorValue = e.currentTarget.value;
    if (!['default', ''].includes(newSelectorValue)) {
      editor.StyleManager.select(newSelectorValue);
      hideComponentNameSpan();
      lastSelected = editor.getSelected().getId();
      lastSelector = newSelectorValue;
    } else {
      const selectedComponent = editor.getSelected();
      editor.selectRemove(selectedComponent);
      editor.select(selectedComponent);

      showComponentNameSpan();
      lastSelected = null;
      lastSelector = null;
    }
  });

  selectorSelect.addEventListener('focus', updateSelectedElementRules);

  editor.on('component:selected', () => {
    selectorSelect.dataset.value = 'default';
    updateSelectorSelectOptions([], null);
    showComponentNameSpan();
    lastSelected = null;
    lastSelector = null;
  });
};

export const addCustomVeevaLink = (editor, { config }) => {
  if (!config.ADD_CUSTOM_VEEVA_LINK) return;

  const customVeevaLinkBlockId = 'Custom-Veeva-Link';
  const customVeevaLinkIdentifier = 'custom-veeva-link';
  const dataSlideTraitName = 'data-slide';
  const dataSlideTraitLabel = 'Data Slide';
  const dataFlowTraitName = 'data-flow';
  const dataFlowTraitLabel = 'Data Flow';
  const gotoButtonClass = 'goToButton';

  const traitOpts = [
    {
      type: 'text',
      name: 'id',
      label: 'ID',
      placeholder: 'Enter id...',
    },
    {
      type: 'text',
      name: dataSlideTraitName,
      label: dataSlideTraitLabel,
      placeholder: 'Enter data-slide...',
    },
    {
      type: 'text',
      name: dataFlowTraitName,
      label: dataFlowTraitLabel,
      default: 'f0',
      placeholder: 'Enter data-flow...',
    },
  ];

  const customVeevaLinkDefaultStyles = {
    display: 'block',
    width: '100px',
    height: '100px',
  };

  editor.DomComponents.addType(customVeevaLinkIdentifier, {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.getAttribute('data-role') === customVeevaLinkIdentifier,

    extend: 'default',
    extendFn: ['init'],

    model: {
      defaults: {
        tagName: 'div',
        removable: true,
        draggable: true,
        droppable: true,
        copyable: true,
        resizable: true,
        attributes: {
          'data-role': customVeevaLinkIdentifier,
          class: gotoButtonClass,
        },
        traits: traitOpts,
      },
    },
  });

  editor.BlockManager.add(customVeevaLinkBlockId, {
    category: 'Components',
    media: `<span class="fa fa-code"></span>`,
    label: `${customVeevaLinkBlockId}`,
    content: {
      type: customVeevaLinkIdentifier,
      style: customVeevaLinkDefaultStyles,
    },
  });

  editor.on('component:selected', (model) => {
    if (model && model.is(customVeevaLinkIdentifier)) {
      const gotoButtonClassSelector = editor.SelectorManager.get(
        `.${gotoButtonClass}`
      );
      const gotoButtonClassActiveStatus = gotoButtonClassSelector.get('active');
      if (gotoButtonClassActiveStatus) {
        gotoButtonClassSelector.set({
          active: false,
        });
      }
    }
  });
};

export const addTabComponent = (editor, opt = {}) => {
  editor.DomComponents.addType('tab', {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'tab' &&
      el.hasAttribute('data-target'),

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        attributes: {
          'data-role': 'tab',
          'data-toggle': 'tab',
          'data-target': '',
          'data-gjs-type': 'tab',
          'data-gjs-name': 'Tab',
        },
        classes: ['nav-link'],
        components: [{ type: 'text', content: 'Tab' }],
        traits: [
          {
            type: 'class_select',
            options: [
              { value: '', name: 'Inactive' },
              { value: 'active', name: 'Active' },
            ],
            label: 'Is Active',
          },
        ],
      },
    },
  });

  // TAB-HEADER DECLRATAION
  editor.DomComponents.addType('tab-header', {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'tab-header',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        draggable: false,
        copyable: false,
        removable: false,
        attributes: {
          id: 'tab-header',
          'data-role': 'tab-header',
          'data-gjs-type': 'tab-header',
          'data-gjs-name': 'tab-header',
        },
        classes: ['nav', 'nav-tabs'],
      },
    },
  });

  //  TAB-CONTENT DECLRATION
  editor.DomComponents.addType('tab-content', {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'tab-content',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        draggable: false,
        attributes: {
          id: 'tab-content',
          'data-role': 'tab-content',
          'data-gjs-type': 'tab-content',
          'data-gjs-name': 'tab-content',
        },
        classes: 'tab-pane',
        components: [{ type: 'text', content: 'Tab Content' }],
        traits: [
          'id',
          {
            type: 'class_select',
            options: [
              { value: '', name: 'Inactive' },
              { value: 'active', name: 'Active' },
            ],
            label: 'Is Active',
          },
        ],
      },
    },
  });

  // TAB-PANE DECLRATION
  editor.DomComponents.addType('tab-pane', {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'tab-pane',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        draggable: false,
        copyable: false,
        removable: false,
        attributes: {
          id: 'tab-pane',
          'data-role': 'tab-pane',
          'data-gjs-type': 'tab-pane',
          'data-gjs-name': 'tab-pane',
        },
        classes: 'tab-content',
      },
    },
  });

  // TAB-CONTAINER DECLARATION
  editor.DomComponents.addType('tab-container', {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'tab-container',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        attributes: {
          'data-role': 'tab-container',
          'data-gjs-type': 'tab-container',
          'data-gjs-name': 'tab-container',
        },
        components: [
          {
            type: 'tab-header',
            components: [
              {
                type: 'tab',
                classes: ['nav-link', 'active'],
              },
              { type: 'tab' },
              { type: 'tab' },
            ],
          },
          {
            type: 'tab-pane',
            components: [
              { type: 'tab-content', classes: ['tab-pane', 'active'] },
              { type: 'tab-content' },
              { type: 'tab-content' },
            ],
          },
        ],
      },
    },
  });

  editor.BlockManager.add('Tab', {
    media: `<span class='fa fa-ellipsis-h'></span>`,
    label: "Tab",
    category: 'Bootstrap Components',
    content: {
      type: 'tab-container',
    },
  });

  editor.on('component:selected', (model) => {
    if (!model.is('tab')) return;
    var selectedComponent = editor.getSelected();

    let tabheaderId;
    if (selectedComponent) {
      var parentElement = selectedComponent.parent();
      tabheaderId = parentElement
        ? parentElement.getAttributes().id.replace('tab-header', '')
          ? parentElement.getAttributes().id.replace('tab-header', '')
          : 'primary'
        : null;
    }
    const allTabContents = editor.getWrapper().findType('tab-content');

    const alltabIds = allTabContents
      .filter((tabContent) => {
        let tabPaneId = tabContent
          .parent()
          .getAttributes()
          .id.replace('tab-pane', '');
        if (tabPaneId === '') {
          tabPaneId = 'primary';
        }
        const tabContentId = tabContent.getAttributes().id;
        return (
          tabContentId &&
          tabContentId !== '' &&
          tabPaneId &&
          tabPaneId === tabheaderId
        );
      })
      .map((tabContent) => `#${tabContent.getAttributes().id}`);
    const tabTrait = model.getTrait('data-target');
    if (tabTrait) {
      tabTrait.set('options', alltabIds);
    } else {
      // const tabCOntentOptions = model.addTrait({
      model.addTrait({
        type: 'select',
        name: 'data-target',
        label: 'Target',
        options: alltabIds,
      });
    }
  });

  editor.on('component:clone', (clonedComponent) => {
    const originalType = clonedComponent.getAttributes()['data-gjs-type'];

    if (originalType === 'tab') {
      var selectedComponent = editor.getSelected();
      var dataTarget = `${selectedComponent.getAttributes()['data-target']}`;
      if (dataTarget) {
        if (selectedComponent.getClasses().includes('active')) {
          clonedComponent.removeClass('active');
        }
        const tabContent = editor
          .getWrapper()
          .find(`[data-role="tab-content"]${dataTarget}`)
          .at(0);
        tabContent.getClasses();
        let activeFlag = false;
        if (tabContent.getClasses().includes('active')) {
          activeFlag = true;
          tabContent.removeClass('active');
        }
        editor.select(tabContent);
        editor.runCommand('core:copy');
        editor.runCommand('core:paste');
        editor.select(selectedComponent);

        if (activeFlag) {
          tabContent.addClass('active');
        }
      } else {
        alert('Please select data-target for tab before cloning!');
        editor.command('core:undo');
      }
    }
  });
};
export const addCarouselComponent = (editor, opt = {}) => {
  // CAROUSEL-ITEM DECLARATION
  editor.DomComponents.addType('carousel-item', {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'carousel-item',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        draggable: false,
        copyable: false,
        removable: false,
        attributes: {
          id: 'carousel-item',
          'data-role': 'carousel-item',
          'data-gjs-type': 'carousel-item',
          'data-gjs-name': 'carousel-item',
          'data-bs-interval': '10000',
          'data-bs-touch': 'true',
        },
        classes: 'carousel-item',
        components: [
          {
            type: 'image',
            attributes: {
              src: 'https://placehold.jp/3d4070/ffffff/600x300.png?text=img1',
              alt: 'Carousel Image 1',
            },
          },
          {
            type: 'text',
            content: 'Carousel Item Content 1',
          },
        ],
        traits: [
          'id',
          {
            type: 'class_select',
            options: [
              { value: '', name: 'Inactive' },
              { value: 'active', name: 'Active' },
            ],
            label: 'Is Active',
          },
        ],
      },
    },
  });
  // CAROUSEL-INDICATOR DECLARATION
  editor.DomComponents.addType('carousel-indicator', {
    isComponent: (el) =>
      el.tagName === 'LI' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'carousel-indicator',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'li',
        draggable: false,
        copyable: false,
        removable: false,
        attributes: {
          'data-role': 'carousel-indicator',
          'data-gjs-type': 'carousel-indicator',
          'data-gjs-name': 'carousel-indicator',
          'data-bs-target': '',
          'data-bs-slide-to': '',
          class: '',
        },
        components: [
          {
            type: 'text',
            content: '',
          },
        ],
      },
    },
  });

  // ... (remaining code)

  // CAROUSEL-CONTROL-PREV DECLARATION
  editor.DomComponents.addType('carousel-control-prev', {
    isComponent: (el) =>
      el.tagName === 'BUTTON' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'carousel-control-prev',

    extend: 'default',
    model: {
      defaults: {
        tagName: 'button',
        draggable: false,
        copyable: false,
        removable: false,
        attributes: {
          'data-role': 'carousel-control-prev',
          'data-gjs-type': 'carousel-control-prev',
          'data-gjs-name': 'carousel-control-prev',
          class: 'carousel-control-prev',
          type: 'button',
          'data-target': '',
          'data-slide': 'prev',
        },
        components: [
          {
            type: 'text',
            content: '',
          },
          {
            type: 'span',
            attributes: {
              class: 'carousel-control-prev-icon',
              'aria-hidden': 'true',
            },
          },
        ],
      },
    },
  });

  // CAROUSEL-CONTROL-NEXT DECLARATION
  editor.DomComponents.addType('carousel-control-next', {
    isComponent: (el) =>
      el.tagName === 'BUTTON' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'carousel-control-next',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'button',
        draggable: false,
        copyable: false,
        removable: false,
        attributes: {
          'data-role': 'carousel-control-next',
          'data-gjs-type': 'carousel-control-next',
          'data-gjs-name': 'carousel-control-next',
          class: 'carousel-control-next',
          type: 'button',
          'data-target': '',
          'data-slide': 'next',
        },
        components: [
          {
            type: 'text',
            content: '',
          },
          {
            type: 'span',
            attributes: {
              class: 'carousel-control-next-icon',
              'aria-hidden': 'true',
            },
          },
        ],
      },
    },
  });

  // CAROUSEL DECLARATION
  editor.DomComponents.addType('bootstrap-carousel', {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'bootstrap-carousel',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        attributes: {
          'data-role': 'bootstrap-carousel',
          'data-bs-ride': 'carousel',
          'data-gjs-type': 'bootstrap-carousel',
          'data-gjs-name': 'bootstrap-carousel',
        },
        classes: 'carousel',
        components: [
          {
            type: 'carousel-inner',
            attributes: {
              'data-gjs-name': 'carousel-inner',
            },
            classes: ['carousel-inner'],
            components: [
              {
                type: 'carousel-item',
                classes: ['carousel-item', 'active'],
              },
              {
                type: 'carousel-item',
              },
              {
                type: 'carousel-item',
              },
            ],
          },
          {
            type: 'carousel-indicators',
            classes: ['carousel-indicators'],
            components: [
              {
                type: 'carousel-indicator',
                classes: ['active'],
              },
              {
                type: 'carousel-indicator',
              },
              {
                type: 'carousel-indicator',
              },
            ],
          },
          {
            type: 'carousel-control-prev',
          },
          {
            type: 'carousel-control-next',
          },
        ],
        traits: [
          {
            type: 'text',
            name: 'prev-keymessage',
            label: 'Default Previous Key Message',
          },
          {
            type: 'text',
            name: 'next-keymessage',
            label: 'Default Next Key Message',
          },
        ],
      },
    },
  });
  // Manually execute the initialization code when a component is added
  editor.on('component:add', (model) => {
    if (model.is('bootstrap-carousel')) {
      const uniqueID = 'carousel_' + Math.random().toString(36).substr(2, 9);
      model.set('attributes', { ...model.get('attributes'), id: uniqueID });
      // model.getTraits().forEach((trait) => {
      //   if (trait.name === 'carousel-id') {
      //     trait.set('value', uniqueID);
      //   }
      // });
      // Update data-bs-target for carousel-control-next
      const nextControl = model
        .find(`[data-role="carousel-control-next"]`)
        .at(0);
      const prevControl = model
        .find(`[data-role="carousel-control-prev"]`)
        .at(0);

      if (nextControl) {
        const targetSelector = `#${uniqueID}`;
        const existingAttributes = nextControl.getAttributes();
        nextControl.setAttributes({
          ...existingAttributes,
          'data-target': targetSelector,
          type: 'button',
        });
      }
      if (prevControl) {
        const targetSelector = `#${uniqueID}`;
        const existingAttributes = prevControl.getAttributes();
        prevControl.setAttributes({
          ...existingAttributes,
          'data-target': targetSelector,
          type: 'button',
        });
      }
    }
  });

  editor.BlockManager.add('BootstrapCarousel', {
    media: `<span class='fa fa-image'></span>`,
    label: "Bootstrap Carousel",
    category: 'Bootstrap Components',
    content: {
      type: 'bootstrap-carousel',
    },
  });

  // // Add default indicators when creating the carousel component
  // editor.on('component:create', (model) => {
  //   if (model.is('bootstrap-carousel')) {
  //     const numSlides = 3; // Default number of slides
  //     let indicatorsHTML = '';

  //     for (let i = 0; i < numSlides; i++) {
  //       const activeClass = i === 0 ? 'active' : '';
  //       indicatorsHTML += `<button type="button" data-bs-target="#${model.getId()}" data-bs-slide-to="${i}" class="${activeClass}" aria-label="Slide ${
  //         i + 1
  //       }"></button>`;
  //     }

  //     // Manually update the HTML of the carousel indicators
  //     const indicatorsEl = document.querySelector(
  //       '[data-role="carousel-indicators"]'
  //     );
  //     if (indicatorsEl) {
  //       indicatorsEl.innerHTML = indicatorsHTML;
  //     } else {
  //       console.error('Carousel indicators element not found');
  //     }

  //     // Refresh the canvas to reflect changes
  //     editor.refresh();
  //   }
  // });

  // // ... (remaining code)

  editor.on('component:clone', (clonedComponent) => {
    const originalType = clonedComponent.getAttributes()['data-gjs-type'];

    if (originalType === 'carousel-item') {
      var selectedComponent = editor.getSelected();
      var dataTarget = `${selectedComponent.getAttributes()['data-target']}`;
      if (dataTarget) {
        if (selectedComponent.getClasses().includes('active')) {
          clonedComponent.removeClass('active');
        }
        const carouselItem = editor
          .getWrapper()
          .find(`[data-role="carousel-item"]${dataTarget}`)
          .at(0);
        carouselItem.getClasses();
        let activeFlag = false;
        if (carouselItem.getClasses().includes('active')) {
          activeFlag = true;
          carouselItem.removeClass('active');
        }
        editor.select(carouselItem);
        editor.runCommand('core:copy');
        editor.runCommand('core:paste');
        editor.select(selectedComponent);

        if (activeFlag) {
          carouselItem.addClass('active');
        }
      } else {
        alert('Please select data-target for carousel item before cloning!');
        editor.command('core:undo');
      }
    }
  });
};

export const addIScroll = (editor) => {
  const iScrollBlockId = 'IScroll-Block';
  const iScrollIdentifier = 'iscroll';
  const scrollbarColorTraitName = 'scrollbar-color';
  const scrollbarColorTraitLabel = 'Scrollbar Color';
  const scrollbarSizeTraitName = 'scrollbar-size';
  const scrollbarSizeTraitLabel = 'Scrollbar Size';
  const scrollbarRailColorTraitName = 'scrollbar-rail-color';
  const scrollbarRailColorTraitLabel = 'Scrollbar Rail color';

  const iScrollDefaultStyles = {
    display: 'block',
    width: '100%',
    height: '200px', // Adjust the height as needed
    overflow: 'hidden',
    position: 'relative',
  };

  const traitOpts = [
    {
      type: 'color',
      name: scrollbarColorTraitName,
      label: scrollbarColorTraitLabel,
      placeholder: 'Scrollbar color',
    },
    {
      type: 'text',
      name: scrollbarSizeTraitName,
      label: scrollbarSizeTraitLabel,
      placeholder: 'Scrollbar size',
    },
    {
      type: 'color',
      name: scrollbarRailColorTraitName,
      label: scrollbarRailColorTraitLabel,
      placeholder: 'Scrollbar Rail color',
    },
  ];

  // Add HTML code
  const htmlCode = `
<div class="scroll-wrapper">
<div class="scroll-slide">
        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
</div>
</div>
  `;

  editor.DomComponents.addType(iScrollIdentifier, {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.getAttribute('data-role') === iScrollIdentifier,

    extend: 'default',
    extendFn: ['init'],

    model: {
      defaults: {
        tagName: 'div',
        removable: true,
        draggable: true,
        droppable: true,
        copyable: true,
        resizable: true,
        attributes: {
          'data-role': iScrollIdentifier,
        },
        traits: traitOpts,
      },
    },
  });

  editor.BlockManager.add(iScrollBlockId, {
    category: 'Components',
    media: `<span class="fa-solid fa-arrows-up-down"></span>`,
    label: `${iScrollBlockId}`,
    content: {
      type: iScrollIdentifier,
      style: iScrollDefaultStyles,
      content: htmlCode, // Set the HTML content
    },
  });
};

export const addMultiCarousel = (editor, opt = {}) => {
  // MULTICAROUSEL-ITEM DECLARATION
  editor.DomComponents.addType('multi-carousel-item', {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'multi-carousel-item',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        draggable: false,
        copyable: true,
        removable: true,
        attributes: {
          id: 'multi-carousel-item',
          'data-role': 'multi-carousel-item',
          'data-gjs-type': 'multi-carousel-item',
          'data-gjs-name': 'multi-carousel-item',
        },
        classes: 'item',
        components: [
          {
            type: 'div',
            classes: ['pad15'],
            components: [
              {
                type: 'text',
                content: 'Multi Item Carousel',
                style: {
                  fontSize: '18px',
                  fontWeight: 'bold',
                },
              },
            ],
          },
        ],
        traits: [
          'id',
          {
            type: 'class_select',
            options: [
              { value: '', name: 'Inactive' },
              { value: 'active', name: 'Active' },
            ],
            label: 'Is Active',
          },
        ],
      },
    },
  });

  // MULTICAROUSEL DECLARATION
  editor.DomComponents.addType('multi-carousel', {
    isComponent: (el) =>
      el.tagName === 'DIV' &&
      el.hasAttribute('data-role') &&
      el.getAttribute('data-role') === 'multi-carousel',

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        attributes: {
          'data-role': 'multi-carousel',
          'data-gjs-type': 'multi-carousel',
          'data-items': '1,4,5,6',
          'data-slide': '1',
          'data-interval': '1000',
        },
        classes: 'MultiCarousel',
        components: [
          {
            type: 'div',
            classes: ['MultiCarousel-inner'],
            style: { height: '75px', overflow: 'hidden' },
            components: [
              // Set the default height here      },
              {
                type: 'multi-carousel-item',
              },
              {
                type: 'multi-carousel-item',
              },
              {
                type: 'multi-carousel-item',
              },
              {
                type: 'multi-carousel-item',
              },
              {
                type: 'multi-carousel-item',
              },
              {
                type: 'multi-carousel-item',
              },
              {
                type: 'multi-carousel-item',
              },
              {
                type: 'multi-carousel-item',
              },
              {
                type: 'multi-carousel-item',
              },
            ],
          },
          {
            type: 'div',
            attributes: {
              role: 'div',
              class: 'btn btn-primary leftLst',
            },
            components: [
              {
                type: 'text',
                content: '<',
              },
            ],
          },
          {
            type: 'div',
            attributes: {
              role: 'div',
              class: 'btn btn-primary rightLst',
            },
            components: [
              {
                type: 'text',
                content: '>',
              },
            ],
          },
        ],
        traits: [
          {
            type: 'text',
            name: 'data-items',
            label: 'Data Items',
          },
        ],
      },
    },
  });

  editor.BlockManager.add('MultiCarousel', {
    media: `<span class='fa fa-image'></span>`,
    label: "Multi Carousel",
    category: 'Bootstrap Components',
    content: {
      type: 'multi-carousel',
    },
  });
};


export const addPlaceholder = (editor) => {
  const divComponentId = 'placeholder';
  const divBlockId = 'placeholder';
  const divBlockLabel = "Placeholder";

  editor.DomComponents.addType(divComponentId, {
    isComponent: (el) => {
      return (
        el.tagName === 'DIV' &&
        el.getAttribute('data-gjs-type') === divComponentId &&
        el.getAttribute('data-gjs-name') === divComponentId
      );
    },

    extend: 'default',

    model: {
      defaults: {
        tagName: 'div',
        removable: true,
        draggable: true,
        droppable: true,
        copyable: true,
        resizable: true,
        attributes: {
          'data-role': divBlockId,
        },
      },
    },
  });

  const divDefaultStyles = {
    display: 'block',
    width: '100px',
    height: '100px',
  };

  editor.BlockManager.add(divBlockId, {
    category: 'Basic',
    media: `<span class="fa-regular fa-square-o"></span>`,
    label: `${divBlockLabel}`,
    content: {
      type: divComponentId,
      style: divDefaultStyles,
    },
  });
};

export const addDefaultPanels = (editor, { pathName }) => {
  editor.on("canvas:drop", (dataTransfer, model) => {
    console.log("drop", dataTransfer);
    console.log("drop - model-", model);
  });

  panels(pathName).defaults.forEach((panel) => {
    editor.Panels.addPanel(panel);
  });
};

export const removeStyleManagerOnComponentDeSelect = (editor) => {
  let decorationsSectorEl = null;

  const hideStyleManager = () => {
    decorationsSectorEl.style.display = "none";
  };

  const showStyleManager = () => {
    decorationsSectorEl.style.display = "";
  };

  editor.on("load", () => {
    decorationsSectorEl = document.querySelector(".tab-content .tab-pane#style");
    hideStyleManager();
  });

  editor.on("component:deselected", hideStyleManager);
  editor.on("component:selected", showStyleManager);
};

export const ensureBodyHasBottomSpace = (editor) => {
  const wrapper = editor.getWrapper();
  const wrapperView = wrapper.view;
  const wrapperView$el = wrapperView.$el;
  const wrapperView$elPreviousStyles = wrapperView$el.attr("style") || "";
  wrapperView$el.attr(
    "style",
    `
    ${wrapperView$elPreviousStyles}
    height: 100% !important;
    max-height: 100% !important;
    padding-bottom: 100px !important;
    `
  );
  // min-height: unset !important;
};

export const removePluginBackgroundColorProperty = (editor) => {
  const backgroundTypeDefaultOptions = editor.StyleManager.getProperty("decorations", "background").getProperty("__background-type").getOptions();
  editor.StyleManager.getProperty("decorations", "background")
    .getProperty("__background-type")
    .setOptions(backgroundTypeDefaultOptions.filter(({ id }) => id !== "color"));
};

export const addCustomAttributeBtn = (editor) => {
  editor.Panels.addButton("util-actions", {
    id: "add-custom-attribute",
    className: "fa fa-plus-square",
    disable: true,
    command: openCustomAttributePopup,
    attributes: {
      title: "Add Custom Attributes",
    },
  });

  editor.on("component:deselected", () => {
    editor.Panels.getButton("util-actions", "add-custom-attribute").set({ disable: true });
  });

  editor.on("component:selected", (model) => {
    if (!model) return;

    editor.Panels.getButton("util-actions", "add-custom-attribute").set({ disable: false });
  });
};

export const addCustomTraitFromAttribute = (editor) => {
  const ATTRIBUTE_PREFIX = "data-custom-";

  const addCustomTrait = (comp) => {
    const compAttributes = comp.getAttributes();
    const customAttributeNames = Object.keys(compAttributes).filter((attribute) => attribute.startsWith(ATTRIBUTE_PREFIX));
    let customAttributes = {};
    customAttributeNames.forEach((attributeName) => {
      customAttributes[attributeName] = compAttributes[attributeName];
    });

    Object.keys(customAttributes).forEach((attributeName) => {
      const attributeValue = customAttributes[attributeName];
      comp.addTrait({
        type: "text",
        label: attributeName.startsWith("data-") ? attributeName.replace("data-custom-", "custom-") : attributeName,
        name: attributeName,
        value: attributeValue,
        placeholder: "Enter custom attribute...",
      });
    });
  };

  addCustomTrait(editor.getWrapper());

  editor.getWrapper().forEachChild(addCustomTrait);

  editor.on("component:add", (model) => {
    if (!model) return;

    addCustomTrait(model);
  });
};

export const addTemplateBg = (editor, config, pathName) => {
  if (!pathName.startsWith("templates") || !config.TEMPLATE_THUMB_AS_BG) return;

  const commandId = "toggle-template-bg";
  const bgImageSrc = `${DOMAIN}/view/${pathName}/template-bg.jpg`;

  const showTemplateBg = (editor) => {
    const $wrapperEl = editor.getWrapper().getView().$el;
    
    $wrapperEl.css({
      "background-repeat": "no-repeat",
      "background-position": "left top",
      "background-attachment": "local",
      "background-size": "1024px 768px",
      "background-image": `url(${bgImageSrc})`,
    });
  }

  const hideTemplateBg = (editor) => {
    const $wrapperEl = editor.getWrapper().getView().$el;

    $wrapperEl.css({
      "background-repeat": "unset",
      "background-position": "unset",
      "background-attachment": "unset",
      "background-size": "unset",
      "background-image": "unset",
    });
  }

  editor.Commands.add(commandId, {
    run: showTemplateBg,
    stop: hideTemplateBg,
  });

  editor.runCommand(commandId);

  editor.getWrapper().getView().$el.css({ backgroundColor: "#000" });

  editor.Panels.addButton("util-actions", {
    id: commandId,
    className: "fa-regular fa-image",
    command: commandId,
    active: true,
    attributes: {
      title: "Toggle Template Bg"
    }
  });
}